// import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import AppLayout from '@/components/feature/AppLayout';
// import ShortcutBar from '@/components/feature/ShortcutBar';
// import ItemEntryTable from '@/pages/billing/components/ItemEntryTable';
// import { type SelectedItem } from '@/pages/billing/components/ItemSearchInput';
// import PrintChallan from '@/components/print/PrintChallan';
// import ConfirmDialog from '@/components/feature/ConfirmDialog';
// import ChallanDetailModal from '@/pages/sales/challans/components/ChallanDetailModal';
// import { useToast } from '@/contexts/ToastContext';
// import { useAuth } from '@/contexts/AuthContext';        // ← added
// import { MODULES } from '@/utils/permissions';           // ← added
// import { useKeyboardNav } from '@/utils/keyboardNav';
// import { useShortcuts } from '@/hooks/useShortcuts';
// import { useBillingTabStore } from '@/stores/billingTabStore';
// import { emptyLineItem, type InvoiceLineItem } from '@/types/billing';
// import type { MockChallanDetail } from '@/mocks/billing';
// import { printChallan } from '@/utils/printDocument';
// import { salesService } from '@/services/salesService';
// import { isBackendAvailable } from '@/api/client';
// import { filterParties, type PartyResponse, getCustomers } from '@/api/party.api';
// import { filterItems, mapApiToItem, type ItemResponse } from '@/api/item.api';
// import type { OutwardGPPrefill } from '@/pages/inventory/gate-pass/outward/page';
// import { deleteData } from "../../../services/FetchNodeServices.js"
// import { useWarehouseStore } from '@/stores/warehouseStore';
// import { useCompanyState } from '@/hooks/useCompanyState';
// import { isSameStateCheck } from '@/utils/gst';

// const STATUS_STYLES: Record<string, string> = {
//   DRAFT: 'bg-slate-100 text-slate-600 border-slate-200',
//   DISPATCHED: 'bg-amber-50 text-amber-700 border-amber-200',
//   CONVERTED: 'bg-green-50 text-green-700 border-green-200',
//   CANCELLED: 'bg-red-50 text-red-600 border-red-200',
// };

// interface Customer { id: string; name: string; address: string, stateCode?: string; }
// interface ItemLookup { id: string; name: string; code: string; unit: string; saleRate: number }

// interface FromInvoiceState {
//   invoiceId: string;
//   invoiceNumber: string;
//   customerId: string;
//   customerName: string;
//   items: Array<{
//     itemId?: string;
//     itemCode?: string;
//     itemName: string;
//     hsnCode: string;
//     qty: number;
//     unit: string;
//     unitId?: string;
//     rate: number;
//     taxRate?: number;
//     cgst?: number;
//     sgst?: number;
//     igst?: number;
//     taxableAmount?: number;
//   }>;
// }

// const buildFrontendChallanNo = () => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const stamp = `${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
//   return `DC-${year}-${stamp}`;
// };

// // ─── Customer search input ────────────────────────────────────────────────────
// function CustomerSearch({
//   value,
//   onChange,
//   onSelect,
// }: {
//   value: string;
//   onChange: (v: string) => void;
//   onSelect: (c: Customer) => void;
// }) {
//   const [options, setOptions] = useState<Customer[]>([]);
//   const [open, setOpen] = useState(false);
//   const [highlighted, setHighlighted] = useState(-1);
//   const { selectedWarehouseId, setSelectedWarehouse } = useWarehouseStore();
//   const [loading, setLoading] = useState(false);
//   const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
//   const wrapRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handler = (e: MouseEvent) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
//     };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   const doSearch = useCallback(async (q: string) => {
//     if (!q.trim()) {
//       setOptions([]);
//       setOpen(false);
//       return;
//     }

//     setLoading(true);

//     try {
//       const res = await getCustomers();

//       const mapped = (res.data ?? [])
//         .filter((p: PartyResponse) =>
//           (p.type === 'Customer' || p.type === 'Both') &&
//           p.name.toLowerCase().includes(q.toLowerCase())
//         )
//         .map((p: PartyResponse) => ({
//           id: p.id,
//           name: p.name,
//           address: p.billing_address ?? '',
//           stateCode: p.state_code ?? '',
//         }));

//       setOptions(mapped);
//       setOpen(true);
//       setHighlighted(-1);

//     } catch {
//       setOptions([]);
//     } finally {
//       setLoading(false);
//     }
//   }, []);


//   // const doSearch = useCallback(async (q: string) => {
//   //   if (!q.trim()) { setOptions([]); setOpen(false); return; }
//   //   setLoading(true);
//   //   try {
//   //     const res = await filterParties({ type: 'customer', isActive: true, search: q });
//   //     const mapped = (res.data ?? [])
//   //       .filter((p: PartyResponse) => p.type === 'Customer' || p.type === 'Both')
//   //       .map((p: PartyResponse) => ({ id: p.id, name: p.name, address: p.billing_address ?? '' , stateCode: p.state_code ?? ''}));
//   //     setOptions(mapped);
//   //     setOpen(true);
//   //     setHighlighted(-1);
//   //   } catch { setOptions([]); }
//   //   finally { setLoading(false); }
//   // }, []);

//   const handleChange = (val: string) => {
//     onChange(val);
//     if (debounceRef.current) clearTimeout(debounceRef.current);
//     debounceRef.current = setTimeout(() => doSearch(val), 300);
//   };

//   const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (!open || !options.length) {
//       if (e.key === 'ArrowDown' && value.trim()) doSearch(value);
//       return;
//     }
//     if (e.key === 'ArrowDown') { e.preventDefault(); setHighlighted((p) => Math.min(p + 1, options.length - 1)); }
//     else if (e.key === 'ArrowUp') { e.preventDefault(); setHighlighted((p) => Math.max(p - 1, 0)); }
//     else if (e.key === 'Enter' && highlighted >= 0) { e.preventDefault(); select(options[highlighted]); }
//     else if (e.key === 'Escape') { setOpen(false); }
//   };

//   const select = (c: Customer) => {
//     onChange(c.name);
//     onSelect(c);
//     setOpen(false);
//     setOptions([]);
//   };

//   return (
//     <div ref={wrapRef} className="relative">
//       <input
//         type="text"
//         value={value}
//         onChange={(e) => handleChange(e.target.value)}
//         onKeyDown={handleKeyDown}
//         onFocus={() => { if (options.length) setOpen(true); }}
//         placeholder="Search customer..."
//         className="w-full h-10 px-3 text-sm bg-white border border-[#e2e8f0] rounded-lg focus:outline-none focus:border-[#4f46e5] focus:ring-2 focus:ring-indigo-100 text-[#1e293b]"
//       />
//       {loading && (
//         <i className="ri-loader-4-line animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
//       )}
//       {open && options.length > 0 && (
//         <div className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border border-[#e2e8f0] rounded-lg shadow-lg max-h-52 overflow-y-auto">
//           {options.map((c, idx) => (
//             <button
//               key={c.id}
//               type="button"
//               onMouseDown={(e) => { e.preventDefault(); select(c); }}
//               onMouseEnter={() => setHighlighted(idx)}
//               className={`w-full text-left px-3 py-2.5 text-sm transition-colors ${idx === highlighted ? 'bg-indigo-50 text-[#4f46e5]' : 'hover:bg-slate-50 text-[#1e293b]'}`}
//             >
//               {c.name}
//             </button>
//           ))}
//         </div>
//       )}
//       {open && !loading && options.length === 0 && value.trim() && (
//         <div className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border border-[#e2e8f0] rounded-lg shadow-sm px-3 py-3 text-xs text-slate-400">
//           No customers found
//         </div>
//       )}
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function ChallansPage() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const toast = useToast();
//   const headerRef = useRef<HTMLDivElement>(null);
//   useKeyboardNav(headerRef as React.RefObject<HTMLElement>);
//   const { addTabWithChallan } = useBillingTabStore();

//   // ── Permission flags ────────────────────────────────────────────────────
//   const { hasPermission, hasControl } = useAuth();
//   const canCreate = hasPermission(MODULES.CHALLAN, 'create');
//   const canUpdate = hasPermission(MODULES.CHALLAN, 'edit');
//   const canDelete = hasPermission(MODULES.CHALLAN, 'delete');
//   // "Convert to Invoice" needs create permission on SALES_INVOICE
//   const canConvert = hasPermission(MODULES.SALES_INVOICE, 'create') || hasControl('convertChallan');
//   // ───────────────────────────────────────────────────────────────────────

//   const [mode, setMode] = useState<'list' | 'new'>('list');
//   const [challans, setChallans] = useState<MockChallanDetail[]>([]);
//   const [detailChallan, setDetailChallan] = useState<MockChallanDetail | null>(null);
//   const [editingChallanId, setEditingChallanId] = useState<string | null>(null);
//   const [deleteConfirmId, setDeleteConfirmId] = useState<string | null>(null);
//   const [fromInvoiceBadge, setFromInvoiceBadge] = useState<string | null>(null);

//   // Form state
//   const [orderMode, setOrderMode] = useState<'order' | 'manual'>('manual');
//   const [customerQuery, setCustomerQuery] = useState('');
//   const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
//   const [selectedOrderId, setSelectedOrderId] = useState('');
//   const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
//   const companyStateCode = useCompanyState();

//   const isSameState = isSameStateCheck(
//     selectedCustomer?.stateCode ?? '',
//     companyStateCode
//   );
//   /**
//    * Challan No is AUTO-GENERATED by the backend.
//    * We show '' initially (placeholder "Auto Generated") and populate
//    * it either from the backend /next-number endpoint (if available)
//    * or keep it empty — the backend returns the real number on save.
//    */
//   const [challanNo, setChallanNo] = useState('');
//   const [loadingChallanNo, setLoadingChallanNo] = useState(false);

//   const { selectedWarehouseId: warehouseId } = useWarehouseStore();
//   const [itemLookup, setItemLookup] = useState<ItemLookup[]>([]);
//   const [vehicleNo, setVehicleNo] = useState('');
//   const [driverName, setDriverName] = useState('');
//   const [lrNo, setLrNo] = useState('');
//   const [items, setItems] = useState<InvoiceLineItem[]>([emptyLineItem()]);
//   const [saving, setSaving] = useState(false);
//   const [printOpen, setPrintOpen] = useState(false);
//   const [loadingChallans, setLoadingChallans] = useState(false);

//   type PendingOrderItem = {
//     id: string; itemId: string; itemCode: string; itemName: string; hsnCode: string;
//     qty: number; unit: string; rate: number; discount: number; taxRate: number;
//     taxableAmount: number; cgst: number; sgst: number; igst: number; total: number;
//   };
//   type PendingOrder = {
//     id: string; orderNo: string; date: string; grandTotal: number;
//     items: PendingOrderItem[];
//   };
//   type PendingInvoice = {
//     id: string; invoiceNo: string; date: string; paymentStatus: string;
//     grandTotal: number; balanceDue: number; items: PendingOrderItem[];
//   };

//   const [pendingOrders, setPendingOrders] = useState<PendingOrder[]>([]);
//   const [pendingInvoices, setPendingInvoices] = useState<PendingInvoice[]>([]);
//   const [loadingPending, setLoadingPending] = useState(false);
//   const [selectedInvoiceIds, setSelectedInvoiceIds] = useState<string[]>([]);

//   // Compute allowed items for current customer and order mode
//   const allowedItems = useMemo(() => {
//     if (!selectedCustomer || orderMode !== 'order') return undefined;
//     const itemsList: SelectedItem[] = [];
//     const seenIds = new Set<string>();

//     const addItems = (itemsArray: PendingOrderItem[]) => {
//       for (const item of itemsArray) {
//         if (!item.itemId || seenIds.has(item.itemId)) continue;
//         seenIds.add(item.itemId);
//         itemsList.push({
//           id: item.itemId,
//           name: item.itemName,
//           code: item.itemCode || '',
//           hsnCode: item.hsnCode || '',
//           taxRate: Number(item.taxRate ?? 18),
//           purchaseRate: Number(item.rate ?? 0),
//           saleRate: Number(item.rate ?? 0),
//           currentStock: Number(item.qty ?? 0),
//           unit: item.unit || 'Pcs',
//           unitId: '',
//           isActive: true
//         });
//       }
//     };

//     pendingOrders.forEach(o => addItems(o.items));

//     return itemsList;
//   }, [selectedCustomer, orderMode, pendingOrders]);

//   // ── Fetch pending orders when customer changes (Against Sales Order mode) ─
//   useEffect(() => {
//     if (orderMode !== 'order' || !selectedCustomer?.id) {
//       setPendingOrders([]);
//       setSelectedInvoiceIds([]);
//       return;
//     }
//     let mounted = true;
//     setLoadingPending(true);
//     salesService.getCustomerPendingOrders(selectedCustomer.id)
//       .then((data) => {
//         if (mounted) {
//           setPendingOrders(data.map((o: any) => ({
//             id: o.id,
//             orderNo: o.invoiceNo, // backend maps it under invoiceNo
//             date: o.date,
//             grandTotal: o.grandTotal,
//             paymentStatus: o.paymentStatus || 'UNPAID',
//             items: o.items || [],
//           })));
//         }
//       })
//       .catch(() => { if (mounted) setPendingOrders([]); })
//       .finally(() => { if (mounted) setLoadingPending(false); });
//     return () => { mounted = false; };
//   }, [orderMode, selectedCustomer?.id]);

//   // ── Fetch pending invoices when customer changes (Without Order mode) ─────
//   useEffect(() => {
//     if (orderMode !== 'manual' || !selectedCustomer?.id) {
//       setPendingInvoices([]);
//       setSelectedInvoiceIds([]);
//       return;
//     }
//     let mounted = true;
//     setLoadingPending(true);
//     salesService.getCustomerPendingInvoices(selectedCustomer.id)
//       .then((data) => {
//         if (mounted) {
//           setPendingInvoices(data.map((inv: any) => ({
//             id: inv.id,
//             invoiceNo: inv.invoiceNo,
//             date: inv.date,
//             paymentStatus: inv.paymentStatus,
//             grandTotal: inv.grandTotal,
//             balanceDue: inv.balanceDue,
//             items: inv.items || [],
//           })));
//         }
//       })
//       .catch(() => { if (mounted) setPendingInvoices([]); })
//       .finally(() => { if (mounted) setLoadingPending(false); });
//     return () => { mounted = false; };
//   }, [orderMode, selectedCustomer?.id]);

//   const toggleInvoiceSelection = (invoiceId: string) => {
//     setSelectedInvoiceIds((prev) => {
//       const isSelected = prev.includes(invoiceId);
//       const newSelected = isSelected ? prev.filter((id) => id !== invoiceId) : [...prev, invoiceId];

//       const updatedItems: InvoiceLineItem[] = [];

//       if (orderMode === 'order') {
//         pendingOrders.forEach((o) => {
//           if (newSelected.includes(o.id)) {
//             o.items.forEach((it) => {
//               updatedItems.push({
//                 ...emptyLineItem(),
//                 id: crypto.randomUUID(),
//                 itemId: it.itemId,
//                 itemCode: it.itemCode,
//                 itemName: it.itemName,
//                 hsnCode: it.hsnCode,
//                 qty: it.qty > 0 ? it.qty : 1,
//                 unit: it.unit || 'Pcs',
//                 rate: it.rate,
//                 discount: it.discount,
//                 taxRate: it.taxRate,
//                 taxableAmount: it.taxableAmount,
//                 cgst: it.cgst,
//                 sgst: it.sgst,
//                 igst: it.igst,
//                 total: it.total,
//                 invoiceId: o.id,
//                 invoiceNo: o.orderNo,
//               });
//             });
//           }
//         });
//       } else {
//         pendingInvoices.forEach((inv) => {
//           if (newSelected.includes(inv.id)) {
//             inv.items.forEach((it) => {
//               updatedItems.push({
//                 ...emptyLineItem(),
//                 id: crypto.randomUUID(),
//                 itemId: it.itemId,
//                 itemCode: it.itemCode,
//                 itemName: it.itemName,
//                 hsnCode: it.hsnCode,
//                 qty: it.qty > 0 ? it.qty : 1,
//                 unit: it.unit || 'Pcs',
//                 rate: it.rate,
//                 discount: it.discount,
//                 taxRate: it.taxRate,
//                 taxableAmount: it.taxableAmount,
//                 cgst: it.cgst,
//                 sgst: it.sgst,
//                 igst: it.igst,
//                 total: it.total,
//                 invoiceId: inv.id,
//                 invoiceNo: inv.invoiceNo,
//               });
//             });
//           }
//         });
//       }

//       if (updatedItems.length > 0) {
//         setItems(updatedItems);
//       } else {
//         setItems([emptyLineItem()]);
//       }

//       return newSelected;
//     });
//   };

//   const resetForm = useCallback(() => {
//     setEditingChallanId(null);
//     setCustomerQuery('');
//     setSelectedCustomer(null);
//     setDate(new Date().toISOString().slice(0, 10));
//     setVehicleNo('');
//     setDriverName('');
//     setLrNo('');
//     setItems([emptyLineItem()]);
//     setFromInvoiceBadge('');
//     setSelectedInvoiceIds([]);
//     setSelectedOrderId('');
//     setOrderMode('manual');
//   }, []);

//   // ── Fetch next challan number from backend when entering new mode ──────
//   const fetchNextChallanNo = useCallback(async () => {
//     setLoadingChallanNo(true);
//     try {
//       setChallanNo(buildFrontendChallanNo());
//     } catch (err) {
//       console.error('Error initializing challan number:', err);
//       setChallanNo(buildFrontendChallanNo());
//     } finally {
//       setLoadingChallanNo(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (mode === 'new') void fetchNextChallanNo();
//   }, [mode, fetchNextChallanNo]);

//   const handleGenerateOutwardGPFromChallan = async (challan: MockChallanDetail) => {
//     let challanDetail = challan;

//     if (!challan.items || challan.items.length === 0) {
//       try {
//         if (!isBackendAvailable()) {
//           toast.error('Cannot fetch challan details');
//           return;
//         }

//         const detail = await salesService.getChallan(challan.id);
//         challanDetail = {
//           ...challan,
//           id: detail.id,
//           billNo: detail.invoiceNo || challan.billNo,
//           partyName: detail.partyName || challan.partyName,
//           items: (detail.items ?? []).map((item, index) => ({
//             id: item.id || `${challan.id}-item-${index}`,
//             itemName: String((item as any).itemName || (item as any).item_name || '—'),
//             qty: Number((item as any).qty || (item as any).quantity || 0),
//             unit: String((item as any).unit || (item as any).unitName || 'Pcs'),
//             rate: Number((item as any).rate || 0),
//             amount: Number((item as any).amount || 0),
//           })),
//         };
//       } catch {
//         toast.error('Failed to load challan details');
//         return;
//       }
//     }

//     const prefill: OutwardGPPrefill = {
//       partyName: challanDetail.partyName,
//       linkedDocType: 'CHALLAN',
//       linkedDocNumber: challanDetail.id,
//       notes: `Generated from Challan ${challanDetail.billNo}`,
//       items: (challanDetail.items || []).map((i) => ({
//         itemName: i.itemName,
//         qty: i.qty,
//         unit: i.unit || 'Pcs',
//         description: `${i.itemName} - Qty: ${i.qty}`,
//       })),
//     };
//     navigate('/inventory/gate-pass/outward', { state: { prefill } });
//   };

//   // ── Edit challan ─────────────────────────────────────────────────────────
//   const handleEditChallan = useCallback(async (challan: MockChallanDetail) => {
//     try {
//       const detail = await salesService.getChallan(challan.id);
//       const rawItems = (detail.items as unknown as Array<{
//         id: string; itemId?: string; itemName?: string; item_name?: string;
//         hsnCode?: string; hsn_code?: string; qty?: number; quantity?: number;
//         unit?: string; unitName?: string; rate?: number; taxRate?: number;
//         cgst?: number; sgst?: number; igst?: number; taxableAmount?: number;
//       }>) ?? [];

//       setEditingChallanId(challan.id);
//       setCustomerQuery(detail.partyName || challan.partyName);
//       // We can't easily get customerId from list row — use id from detail if available
//       setSelectedCustomer({
//         id: (detail as any).customerId || (detail as any).customer_id || '',
//         name: detail.partyName || challan.partyName,
//         address: (detail as any).billingAddress || challan.billingAddress || '',
//       });
//       setDate(detail.date || challan.date);
//       setVehicleNo(detail.vehicleNo || challan.vehicleNo || '');
//       setDriverName(detail.driverName || challan.driverName || '');
//       setLrNo(detail.lrNo || challan.lrNo || '');
//       setItems(rawItems.length > 0 ? rawItems.map((item) => ({
//         ...emptyLineItem(),
//         itemId: item.itemId ?? '',
//         itemCode: '',
//         itemName: item.itemName ?? item.item_name ?? '',
//         hsnCode: item.hsnCode ?? item.hsn_code ?? '',
//         qty: Number(item.qty ?? item.quantity ?? 1),
//         unit: item.unit ?? item.unitName ?? 'Pcs',
//         rate: Number(item.rate ?? 0),
//         taxRate: Number(item.taxRate ?? 0),
//         cgst: Number(item.cgst ?? 0),
//         sgst: Number(item.sgst ?? 0),
//         igst: Number(item.igst ?? 0),
//         taxableAmount: Number(item.taxableAmount ?? 0),
//       })) : [emptyLineItem()]);
//       setMode('new');
//     } catch {
//       toast.error('Failed to load challan for editing');
//     }
//   }, [toast]);

//   const handleDeleteChallan = async (id: string) => {

//     const respons = await deleteData(`api/v1/challans/${id}`)
//     if (respons.success === true) {
//       setChallans((prev) => prev.filter((c) => c.id !== id));
//       toast.success('Challan removed (frontend only)');
//       setDeleteConfirmId(null);
//     }

//   };

//   useEffect(() => {
//     let mounted = true;
//     const loadData = async () => {
//       if (mounted) setLoadingChallans(true);
//       try {
//         const tasks = await Promise.allSettled([
//           isBackendAvailable()
//             ? salesService.listChallans({
//               page: 1,
//               limit: 200,
//               warehouseId,
//             })
//             : Promise.resolve(null),
//           filterItems({}),
//         ]);
//         if (!mounted) return;

//         const challansResult = tasks[0];
//         if (challansResult.status === 'fulfilled' && challansResult.value) {
//           const mapped: MockChallanDetail[] = challansResult.value.items.map((row) => ({
//             id: row.id,
//             billNo: row.invoiceNo,
//             date: row.date,
//             partyName: row.partyName || '—',
//             warehouseName: row.warehouseName || '—',
//             itemCount: row.itemCount || 0,
//             grandTotal: row.grandTotal || 0,
//             status: (row.status as MockChallanDetail['status']) || 'SAVED',
//             challanStatus: (row.status as MockChallanDetail['challanStatus']) || 'DISPATCHED',
//             vehicleNo: row.vehicleNo || '',
//             driverName: row.driverName || '',
//             lrNo: row.lrNo || '',
//             billingAddress: row.billingAddress || '',
//             items: (row.items as MockChallanDetail['items']) || [],
//           }));
//           setChallans(mapped);
//         }

//         // tasks[1] is now itemsResult (was tasks[2] before)
//         const itemsResult = tasks[1];
//         if (itemsResult.status === 'fulfilled') {
//           setItemLookup((itemsResult.value.data ?? []).map((row: ItemResponse) => {
//             const item = mapApiToItem(row);
//             return { id: item.id, name: item.name, code: item.code, unit: item.unitName || 'Pcs', saleRate: item.saleRate };
//           }));
//         }
//       } finally {
//         if (mounted) setLoadingChallans(false);
//       }
//     };
//     void loadData();
//     return () => { mounted = false; };
//   }, [warehouseId]);

//   // useEffect(() => {
//   //   const state = location.state as { fromInvoice?: FromInvoiceState } | null;
//   //   if (!state?.fromInvoice) return;
//   //   const inv = state.fromInvoice;
//   //   setMode('new');
//   //   setOrderMode('order');
//   //   setFromInvoiceBadge(inv.invoiceNumber);
//   //   setCustomerQuery(inv.customerName);
//   //   setSelectedCustomer({ id: inv.customerId, name: inv.customerName, address: '' });
//   //   setItems(inv.items.map((i) => ({
//   //     ...emptyLineItem(),
//   //     itemId: i.itemId ?? '',
//   //     itemCode: i.itemCode ?? '',
//   //     itemName: i.itemName,
//   //     hsnCode: i.hsnCode ?? '',
//   //     qty: i.qty > 0 ? i.qty : 1,
//   //     unit: i.unit,
//   //     unitId: i.unitId ?? '',
//   //     rate: i.rate,
//   //     taxRate: i.taxRate ?? 0,
//   //   cgst: i.cgst ?? 0,
//   //   sgst: i.sgst ?? 0,
//   //   igst: i.igst ?? 0,
//   //   taxableAmount: i.taxableAmount ?? (i.qty * i.rate),
//   //   })));
//   //   navigate(location.pathname, { replace: true, state: null });
//   // }, [location, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

//   useEffect(() => {
//     const state = location.state as { fromInvoice?: FromInvoiceState } | null;
//     if (!state?.fromInvoice) return;
//     const inv = state.fromInvoice;

//     setMode('new');
//     setOrderMode('order'); // Pre-filled from invoice → show "Against Sales Order" tab
//     setFromInvoiceBadge(inv.invoiceNumber);
//     setCustomerQuery(inv.customerName);
//     setSelectedCustomer({ id: inv.customerId, name: inv.customerName, address: '' });
//     setSelectedInvoiceIds([inv.invoiceId]);
//     setItems(inv.items.map((i) => ({
//       ...emptyLineItem(),
//       itemId: i.itemId ?? '',
//       itemCode: i.itemCode ?? '',
//       itemName: i.itemName,
//       hsnCode: i.hsnCode ?? '',
//       qty: i.qty > 0 ? i.qty : 1,
//       unit: i.unit,
//       unitId: i.unitId ?? '',
//       rate: i.rate,
//       taxRate: i.taxRate ?? 0,
//       cgst: i.cgst ?? 0,
//       sgst: i.sgst ?? 0,
//       igst: i.igst ?? 0,
//       taxableAmount: i.taxableAmount ?? (i.qty * i.rate),
//       invoiceId: inv.invoiceId,
//       invoiceNo: inv.invoiceNumber,
//     })));

//     // Clear state AFTER a tick so items are set first
//     setTimeout(() => {
//       navigate(location.pathname, { replace: true, state: null });
//     }, 100);
//   }, [location.state]); // ← only depend on location.STATE not entire location object

//   const selectedOrder = pendingOrders.find((o) => o.id === selectedOrderId);

//   const resolveItemIdentity = useCallback((row: InvoiceLineItem): InvoiceLineItem => {
//     if (row.itemId) return row;
//     const qName = row.itemName.trim().toLowerCase();
//     const qCode = row.itemCode.trim().toLowerCase();
//     const found = itemLookup.find((item) => {
//       const byName = qName && item.name.trim().toLowerCase() === qName;
//       const byCode = qCode && item.code.trim().toLowerCase() === qCode;
//       return byName || byCode;
//     });
//     if (!found) return row;
//     return { ...row, itemId: found.id, itemCode: row.itemCode || found.code, itemName: row.itemName || found.name, unit: row.unit || found.unit, rate: row.rate || found.saleRate };
//   }, [itemLookup]);

//   const loadChallanDetail = useCallback(async (challanId: string): Promise<MockChallanDetail | null> => {
//     try {
//       const detail = await salesService.getChallan(challanId);
//       return {
//         id: detail.id, billNo: detail.invoiceNo, date: detail.date,
//         partyName: detail.partyName || '—', warehouseName: detail.warehouseName || '—',
//         itemCount: detail.itemCount || 0, grandTotal: detail.grandTotal || 0,
//         status: (detail.status as MockChallanDetail['status']) || 'SAVED',
//         challanStatus: (detail.status as MockChallanDetail['challanStatus']) || 'DISPATCHED',
//         vehicleNo: detail.vehicleNo || '', driverName: detail.driverName || '',
//         lrNo: detail.lrNo || '', billingAddress: detail.billingAddress || '',
//         items: ((detail.items as unknown as Array<{
//           id: string; itemName: string; qty: number; unit: string;
//           rate?: number; amount?: number; hsnCode?: string;
//           taxRate?: number; cgst?: number; sgst?: number; igst?: number; taxableAmount?: number;
//         }>) ?? []).map((item, idx) => ({
//           id: item.id || `dci-${idx}`,
//           itemName: item.itemName,
//           qty: Number(item.qty || 0),
//           unit: item.unit || 'Pcs',
//           rate: item.rate,
//           amount: item.amount,
//           hsnCode: item.hsnCode,
//           taxRate: item.taxRate,
//           cgst: item.cgst,
//           sgst: item.sgst,
//           igst: item.igst,
//           taxableAmount: item.taxableAmount,
//         })),
//       };
//     } catch { toast.error('Failed to load challan details'); return null; }
//   }, [toast]);

//   const handleFetchOrderItems = () => {
//     if (!selectedOrder) { toast.error('Select an order first'); return; }
//     setItems(selectedOrder.items.map((i) => ({
//       ...emptyLineItem(),
//       id: crypto.randomUUID(),
//       itemId: i.itemId,
//       itemCode: i.itemCode,
//       itemName: i.itemName,
//       hsnCode: i.hsnCode,
//       qty: i.qty > 0 ? i.qty : 1,
//       unit: i.unit || 'Pcs',
//       rate: i.rate,
//       discount: i.discount,
//       taxRate: i.taxRate,
//       taxableAmount: i.taxableAmount,
//       cgst: i.cgst,
//       sgst: i.sgst,
//       igst: i.igst,
//       total: i.total,
//       invoiceId: selectedOrder.id,
//     })));
//     toast.success(`Fetched ${selectedOrder.items.length} items from ${selectedOrder.orderNo}`);
//   };

//   const handleSave = useCallback(async (andNew = false) => {
//     if (!selectedCustomer) { toast.error('Select a customer'); return; }
//     if (!warehouseId) { toast.error('Select a warehouse'); return; }
//     if (!selectedCustomer.id) { toast.error('Customer selection is invalid. Please re-select.'); return; }
//     const validItems = items.filter((i) => i.itemName && i.qty > 0);
//     if (!validItems.length) { toast.error('Add at least one item'); return; }
//     const normalizedItems = validItems.map(resolveItemIdentity);
//     const unresolved = normalizedItems.filter((i) => !i.itemId);
//     if (unresolved.length) { toast.error(`Select valid item from dropdown for: ${unresolved[0].itemName}`); return; }

//     setSaving(true);
//     await new Promise((r) => setTimeout(r, 300));

//     const selectedWarehouseName = '—';
//     let newChallan: MockChallanDetail = {
//       id: editingChallanId ?? `dc-new-${Date.now()}`,
//       billNo: challanNo || 'Auto Generated',
//       date,
//       partyName: selectedCustomer.name,
//       warehouseName: selectedWarehouseName,
//       itemCount: normalizedItems.length,
//       grandTotal: Number(normalizedItems.reduce((sum, item) => sum + (item.qty * item.rate), 0).toFixed(2)),
//       status: 'SAVED',
//       challanStatus: 'DISPATCHED',
//       vehicleNo, driverName, lrNo,
//       billingAddress: selectedCustomer.address,
//       items: normalizedItems.map((i, idx) => ({
//         id: `dci-new-${idx}`,
//         itemId: i.itemId,
//         itemCode: i.itemCode,
//         itemName: i.itemName,
//         hsnCode: i.hsnCode,
//         qty: i.qty,
//         unit: i.unit,
//         unitId: i.unitId,
//         rate: i.rate,
//         amount: i.qty * i.rate,
//         taxRate: i.taxRate,
//         cgst: i.cgst,
//         sgst: i.sgst,
//         igst: i.igst,
//         taxableAmount: i.taxableAmount,
//       })),
//     };

//     const challanPayload = {
//       customerId: selectedCustomer.id,
//       warehouseId,
//       date,
//       vehicleNo,
//       driverName,
//       lrNo,
//       items: normalizedItems.map((i) => ({
//         itemId: i.itemId,
//         qty: Number(i.qty || 0),
//         unit: i.unit || 'Pcs',
//         rate: Number(i.rate || 0),
//         taxRate: Number(i.taxRate || 0),
//         taxableAmount: Number(i.taxableAmount || i.qty * i.rate),
//         cgst: Number(i.cgst || 0),
//         sgst: Number(i.sgst || 0),
//         igst: Number(i.igst || 0),
//         invoiceId: i.invoiceId || null,
//       })),
//     };

//     if (isBackendAvailable()) {
//       try {
//         const saved = editingChallanId
//           ? await salesService.updateChallan(editingChallanId, challanPayload)
//           : await salesService.createChallan(challanPayload);

//         newChallan = {
//           ...newChallan,
//           id: saved.id,
//           billNo: saved.invoiceNo,
//           date: saved.date,
//           partyName: saved.partyName || newChallan.partyName,
//           warehouseName: saved.warehouseName || newChallan.warehouseName,
//           itemCount: saved.itemCount || newChallan.itemCount,
//           grandTotal: saved.grandTotal || newChallan.grandTotal,
//           status: (saved.status as MockChallanDetail['status']) || newChallan.status,
//           challanStatus: (saved.status as MockChallanDetail['challanStatus']) || newChallan.challanStatus,
//         };
//       } catch (error) {
//         const message = error instanceof Error ? error.message : 'Failed to save challan';
//         toast.error(message);
//         setSaving(false);
//         return;
//       }
//     }

//     // Update local list
//     if (editingChallanId) {
//       setChallans((prev) => prev.map((c) => c.id === editingChallanId ? newChallan : c));
//     } else {
//       setChallans((prev) => [newChallan, ...prev]);
//     }

//     setSaving(false);
//     toast.success(editingChallanId ? `Challan ${newChallan.billNo} updated!` : `Challan ${newChallan.billNo} saved!`);

//     if (andNew) {
//       setItems([emptyLineItem()]); setSelectedCustomer(null); setCustomerQuery('');
//       setVehicleNo(''); setDriverName(''); setLrNo(''); setSelectedOrderId('');
//       setEditingChallanId(null);
//       void fetchNextChallanNo();
//     } else {
//       setEditingChallanId(null);
//       setMode('list');
//     }
//   }, [selectedCustomer, warehouseId, items, challanNo, date, vehicleNo, driverName, lrNo, editingChallanId, toast, resolveItemIdentity, fetchNextChallanNo]);

//   useShortcuts('challan-new', {
//     F8: () => handleSave(true),
//     F9: () => handleSave(false),
//     F10: () => setPrintOpen(true),
//     Escape: () => setMode('list'),
//   });

//   const buildPrintData = () => ({
//     challanNo: challanNo || 'Auto Generated',
//     date,
//     customerName: selectedCustomer?.name ?? '—',
//     billingAddress: selectedCustomer?.address ?? '',
//     vehicleNo, driverName, lrNo,
//     items: items.filter((i) => i.itemName).map((i, idx) => ({ sr: idx + 1, name: i.itemName, qty: i.qty, unit: i.unit })),
//   });

//   const fl = 'w-full h-10 px-3 text-sm bg-white border border-[#e2e8f0] rounded-lg focus:outline-none focus:border-[#4f46e5] focus:ring-2 focus:ring-indigo-100 text-[#1e293b]';
//   const lb = 'block text-xs font-semibold text-slate-500 mb-1';

//   // ─── NEW / EDIT CHALLAN VIEW ──────────────────────────────────────────────
//   if (mode === 'new') return (
//     <AppLayout>
//       <div className="flex flex-col h-full">
//         <div className="flex-1 overflow-y-auto p-6 pb-16 bg-[#f8fafc]">
//           <div className="flex items-center justify-between mb-4">
//             <div>
//               <div className="flex items-center gap-3">
//                 <h1 className="text-lg font-bold text-[#1e293b]">
//                   {editingChallanId ? 'Edit Delivery Challan' : 'New Delivery Challan'}
//                 </h1>
//                 {fromInvoiceBadge && (
//                   <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 font-medium">
//                     <i className="ri-file-list-3-line" />
//                     Pre-filled from Invoice: {fromInvoiceBadge}
//                   </span>
//                 )}
//               </div>
//               <p className="text-sm text-slate-500">
//                 {loadingChallanNo
//                   ? 'Fetching challan number...'
//                   : challanNo
//                     ? `${challanNo} — No stock movement on save`
//                     : 'Challan No. will be auto-generated on save'}
//               </p>
//             </div>
//             <div className="flex items-center gap-2">
//               <button onClick={() => handleSave(true)} disabled={saving}
//                 className="flex items-center gap-1.5 h-9 px-3 rounded-lg border border-[#e2e8f0] text-sm font-medium text-[#64748b] hover:bg-[#f1f5f9] disabled:opacity-50 cursor-pointer whitespace-nowrap">
//                 <i className="ri-save-line text-xs" /> Save &amp; New <kbd className="text-[10px] bg-[#e2e8f0] px-1 rounded ml-0.5">F8</kbd>
//               </button>
//               <button onClick={() => handleSave(false)} disabled={saving}
//                 className="flex items-center gap-1.5 h-9 px-4 rounded-lg bg-[#4f46e5] text-white text-sm font-semibold hover:bg-indigo-700 disabled:opacity-60 cursor-pointer whitespace-nowrap">
//                 {saving ? <><i className="ri-loader-4-line animate-spin" /> Saving...</> : <><i className="ri-save-3-line" /> Save <kbd className="text-[10px] bg-white/20 px-1 rounded ml-0.5">F9</kbd></>}
//               </button>
//             </div>
//           </div>

//           {/* Order mode toggle */}
//           <div className="bg-white border border-[#e2e8f0] rounded-xl p-4 mb-4">
//             <div className="flex items-center gap-6">
//               {(['manual', 'order'] as const).map((m) => (
//                 <label key={m} className="flex items-center gap-2.5 cursor-pointer">
//                   <input type="radio" name="orderMode" value={m} checked={orderMode === m}
//                     onChange={() => { setOrderMode(m); setSelectedOrderId(''); setSelectedInvoiceIds([]); setItems([emptyLineItem()]); }}
//                     className="w-4 h-4 text-[#4f46e5] border-slate-300 focus:ring-[#4f46e5] cursor-pointer"
//                   />
//                   <span className="text-sm font-medium text-[#1e293b]">
//                     {m === 'manual' ? 'Without Order' : 'Against Sales Order'}
//                   </span>
//                   {m === 'order' && <span className="text-xs text-[#94a3b8]">(fetch items from order)</span>}
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* Challan details */}
//           <div ref={headerRef} className="bg-white border border-[#e2e8f0] rounded-xl p-5 mb-4">
//             <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-4">Challan Details</h2>
//             <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//               <div className="lg:col-span-2">
//                 <label className={lb}>Customer <span className="text-red-500">*</span></label>
//                 <CustomerSearch
//                   value={customerQuery}
//                   onChange={setCustomerQuery}
//                   onSelect={(c) => { setSelectedCustomer(c); setCustomerQuery(c.name); setSelectedOrderId(''); setSelectedInvoiceIds([]); setItems([emptyLineItem()]); }}
//                 />
//               </div>
//               <div>
//                 <label className={lb}>Date</label>
//                 <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={fl} />
//               </div>
//               <div>
//                 <label className={lb}>
//                   Challan No
//                   <span className="ml-1 text-[10px] font-normal text-slate-400">(auto generated)</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     readOnly value={challanNo} placeholder="Auto Generated"
//                     className="w-full h-10 px-3 text-sm bg-slate-50 border border-[#e2e8f0] rounded-lg text-slate-400 cursor-not-allowed italic placeholder:not-italic placeholder:text-slate-400"
//                   />
//                   {loadingChallanNo && (
//                     <i className="ri-loader-4-line animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
//                   )}
//                 </div>
//               </div>
//               <div>
//                 <label className={lb}>Vehicle No</label>
//                 <input value={vehicleNo} onChange={(e) => setVehicleNo(e.target.value)} className={fl} placeholder="MH-12-AB-1234" />
//               </div>
//               <div>
//                 <label className={lb}>Driver Name</label>
//                 <input value={driverName} onChange={(e) => setDriverName(e.target.value)} className={fl} placeholder="Driver name" />
//               </div>
//               <div>
//                 <label className={lb}>LR No</label>
//                 <input value={lrNo} onChange={(e) => setLrNo(e.target.value)} className={fl} placeholder="Lorry receipt no" />
//               </div>
//             </div>

//             {selectedCustomer && (
//               <div className="mt-4 pt-4 border-t border-[#e2e8f0]" >
//                 {orderMode === 'order' ? (
//                   <>
//                     <label className={lb}>Pending Sales Orders for {selectedCustomer.name}</label>
//                     {loadingPending ? (
//                       <p className="text-sm text-slate-500 flex items-center gap-1.5 mt-2">
//                         <i className="ri-loader-4-line animate-spin text-[#4f46e5]" /> Loading pending orders...
//                       </p>
//                     ) : !pendingOrders.length ? (
//                       <p className="text-sm text-[#94a3b8] mt-2">No pending orders for this customer</p>
//                     ) : (
//                       <div className="overflow-x-auto border border-[#e2e8f0] rounded-lg mt-2 shadow-sm" style={{ height: '30vh' }}>
//                         <table className="min-w-full divide-y divide-[#e2e8f0] " >
//                           <thead className="bg-slate-50">
//                             <tr>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Invoice No</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Date</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Customer</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Amount</th>
//                               <th className="px-4 py-2.5 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider w-20">Select</th>
//                             </tr>
//                           </thead>
//                           <tbody className="bg-white divide-y divide-[#e2e8f0]">
//                             {pendingOrders.map((o) => {
//                               const isChecked = selectedInvoiceIds.includes(o.id);
//                               return (
//                                 <tr key={o.id} className={`hover:bg-slate-50 transition-colors ${isChecked ? 'bg-indigo-50/30' : ''}`}>
//                                   <td className="px-4 py-3 text-sm font-semibold text-[#4f46e5]">{o.orderNo}</td>
//                                   <td className="px-4 py-3 text-sm text-slate-600">
//                                     {new Date(o.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//                                   </td>
//                                   <td className="px-4 py-3 text-sm text-slate-700 font-medium">{selectedCustomer.name}</td>
//                                   <td className="px-4 py-3 text-sm text-slate-800 font-semibold">₹{o.grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                                   <td className="px-4 py-3 text-center">
//                                     <div className="flex justify-center">
//                                       <button
//                                         type="button"
//                                         onClick={() => toggleInvoiceSelection(o.id)}
//                                         className={`w-6 h-6 rounded-md flex items-center justify-center transition-all border ${isChecked
//                                             ? 'bg-indigo-600 border-indigo-600 text-white shadow-sm'
//                                             : 'bg-white border-slate-300 text-transparent hover:border-indigo-500 hover:text-slate-400'
//                                           }`}
//                                       >
//                                         <i className="ri-check-line text-sm font-bold" />
//                                       </button>
//                                     </div>
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <>
//                     <label className={lb}>Pending Invoices for {selectedCustomer.name}</label>
//                     {loadingPending ? (
//                       <p className="text-sm text-slate-500 flex items-center gap-1.5 mt-2">
//                         <i className="ri-loader-4-line animate-spin text-[#4f46e5]" /> Loading pending invoices...
//                       </p>
//                     ) : !pendingInvoices.length ? (
//                       <p className="text-sm text-[#94a3b8] mt-2">No pending invoices for this customer</p>
//                     ) : (
//                       <div className="overflow-x-auto border border-[#e2e8f0] rounded-lg mt-2 shadow-sm">
//                         <table className="min-w-full divide-y divide-[#e2e8f0]">
//                           <thead className="bg-slate-50">
//                             <tr>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Invoice No</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Date</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Customer</th>
//                               <th className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Amount</th>
//                               <th className="px-4 py-2.5 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider w-20">Select</th>
//                             </tr>
//                           </thead>
//                           <tbody className="bg-white divide-y divide-[#e2e8f0]">
//                             {pendingInvoices.map((inv) => {
//                               const isChecked = selectedInvoiceIds.includes(inv.id);
//                               return (
//                                 <tr key={inv.id} className={`hover:bg-slate-50 transition-colors ${isChecked ? 'bg-indigo-50/30' : ''}`}>
//                                   <td className="px-4 py-3 text-sm font-semibold text-[#4f46e5]">{inv.invoiceNo}</td>
//                                   <td className="px-4 py-3 text-sm text-slate-600">
//                                     {new Date(inv.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
//                                   </td>
//                                   <td className="px-4 py-3 text-sm text-slate-700 font-medium">{selectedCustomer.name}</td>
//                                   <td className="px-4 py-3 text-sm text-slate-800 font-semibold">₹{inv.grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
//                                   <td className="px-4 py-3 text-center">
//                                     <div className="flex justify-center">
//                                       <button
//                                         type="button"
//                                         onClick={() => toggleInvoiceSelection(inv.id)}
//                                         className={`w-6 h-6 rounded-md flex items-center justify-center transition-all border ${isChecked
//                                             ? 'bg-indigo-600 border-indigo-600 text-white shadow-sm'
//                                             : 'bg-white border-slate-300 text-transparent hover:border-indigo-500 hover:text-slate-400'
//                                           }`}
//                                       >
//                                         <i className="ri-check-line text-sm font-bold" />
//                                       </button>
//                                     </div>
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                           </tbody>
//                         </table>
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Items */}
//           <div className="bg-white border border-[#e2e8f0] rounded-xl p-5">
//             <div className="flex items-center justify-between mb-3">
//               <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wide">Items</h2>
//               <span className="text-xs text-slate-400">No stock movement — challan is for dispatch only</span>
//             </div>
//             <ItemEntryTable items={items} onChange={setItems} isSameState={isSameState} warehouseId={warehouseId} rateType="sale" allowedItems={allowedItems} />
//           </div>
//         </div>

//         {printOpen && <PrintChallan data={buildPrintData()} onClose={() => setPrintOpen(false)} onPrint={() => printChallan(buildPrintData())} />}
//         <ShortcutBar onSave={() => handleSave(false)} onSaveAndNew={() => handleSave(true)} onPrint={() => setPrintOpen(true)} onBack={() => setMode('list')} saving={saving} />
//       </div>
//     </AppLayout>
//   );

//   // ─── CHALLAN LIST ──────────────────────────────────────────────────────────
//   return (
//     <AppLayout>
//       <div className="p-6 bg-[#f8fafc] min-h-full">
//         <div className="flex items-center justify-between mb-6">
//           <div>
//             <h1 className="text-xl font-bold text-[#1e293b]">Delivery Challans</h1>
//             <p className="text-sm text-slate-500">{challans.length} challans</p>
//           </div>

//           {/* New Challan — only with create permission */}
//           {canCreate && (
//             <button
//               onClick={() => { resetForm(); setMode('new'); }}
//               className="flex items-center gap-2 px-4 py-2 bg-[#4f46e5] text-white text-sm font-medium rounded-lg hover:bg-indigo-700 cursor-pointer whitespace-nowrap"
//             >
//               <i className="ri-add-line" /> New Challan
//             </button>
//           )}
//         </div>

//         <div className="bg-white border border-[#e2e8f0] rounded-xl overflow-hidden">
//           {loadingChallans ? (
//             <div className="flex min-h-[260px] items-center justify-center text-slate-500 text-sm">
//               <div className="flex items-center gap-2">
//                 <i className="ri-loader-4-line animate-spin text-[#4f46e5]" />
//                 Loading challans...
//               </div>
//             </div>
//           ) : (
//             <div className="w-full overflow-x-auto">
//               <table className="w-full min-w-[1000px] text-sm">
//                 <thead className="bg-slate-50">
//                   <tr>
//                     {['Challan No', 'Date', 'Customer', 'Items', 'Status', 'Actions'].map((h) => (
//                       <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-slate-500 border-b border-[#e2e8f0] whitespace-nowrap">{h}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {challans.map((c, i) => (
//                     <tr
//                       key={c.id}
//                       onClick={async () => { const d = await loadChallanDetail(c.id); if (d) setDetailChallan(d); }}
//                       className={`border-b border-slate-50 hover:bg-indigo-50/30 cursor-pointer transition-colors ${i % 2 === 1 ? 'bg-[#f8fafc]' : ''}`}
//                     >
//                       <td className="px-4 py-3 font-medium text-[#4f46e5]">{c.billNo}</td>
//                       {/* <td className="px-4 py-3 text-slate-600">{c.date}</td> */}
//                       <td className="px-4 py-3 text-slate-600 ">
//                         {new Date(c.date).toLocaleDateString('en-IN', {
//                           timeZone: 'Asia/Kolkata',
//                           day: '2-digit',
//                           month: 'short',
//                           year: 'numeric',
//                         })}
//                       </td>
//                       <td className="px-4 py-3 font-medium">{c.partyName}</td>
//                       <td className="px-4 py-3 text-center text-slate-500">{c.itemCount}</td>
//                       <td className="px-4 py-3">
//                         <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${STATUS_STYLES[c.challanStatus] ?? STATUS_STYLES.DRAFT}`}>
//                           {c.challanStatus}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
//                         <div className="flex items-center gap-2 flex-nowrap">

//                           {/* View — always visible */}
//                           <button
//                             onClick={async () => { const d = await loadChallanDetail(c.id); if (d) setDetailChallan(d); }}
//                             className="h-7 px-2.5 rounded-md text-xs font-medium border border-[#e2e8f0] text-slate-600 hover:bg-slate-50 cursor-pointer whitespace-nowrap"
//                           >
//                             View
//                           </button>

//                           {c.challanStatus === 'DISPATCHED' && (
//                             <>
//                               {/* Convert to Invoice — needs SALES_INVOICE create */}
//                               {canConvert && (
//                                 <button
//                                   onClick={async () => {
//                                     const detail = await loadChallanDetail(c.id);
//                                     if (!detail) return;
//                                     if (isBackendAvailable()) {
//                                       try { await salesService.convertChallanToInvoice(c.id); }
//                                       catch { toast.error('Failed to convert challan'); return; }
//                                     }
//                                     addTabWithChallan({
//                                       challanId: detail.id, challanNo: detail.billNo, customerName: detail.partyName,
//                                       items: detail.items.map((i) => ({ itemName: i.itemName, qty: i.qty, unit: i.unit, rate: i.rate ?? 0 })),
//                                     });
//                                     setChallans((prev) => prev.map((ch) => ch.id === c.id ? { ...ch, challanStatus: 'CONVERTED' as const } : ch));
//                                     navigate('/sales/invoices/new');
//                                   }}
//                                   className="text-xs px-3 py-1.5 bg-indigo-50 text-[#4f46e5] border border-indigo-200 rounded-lg hover:bg-indigo-100 cursor-pointer whitespace-nowrap font-medium"
//                                 >
//                                   Convert to Invoice
//                                 </button>
//                               )}

//                               {/* Generate Gate Pass — needs GATE_PASS_OUTWARD create */}
//                               {hasPermission(MODULES.GATE_PASS_OUTWARD, 'create') && (
//                                 <button
//                                   onClick={() => handleGenerateOutwardGPFromChallan(c)}
//                                   className="flex items-center gap-1.5 h-7 px-2.5 rounded-md text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 cursor-pointer whitespace-nowrap"
//                                 >
//                                   <i className="ri-file-shield-2-line" />Generate GP
//                                 </button>
//                               )}
//                             </>
//                           )}

//                           {/* Edit — only with update permission */}
//                           {canUpdate && (
//                             <button
//                               onClick={() => handleEditChallan(c)}
//                               title="Edit challan"
//                               className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 cursor-pointer"
//                             >
//                               <i className="ri-edit-line text-xs" />
//                             </button>
//                           )}

//                           {/* Delete — only with delete permission */}
//                           {canDelete && (
//                             <button
//                               onClick={() => setDeleteConfirmId(c.id)}
//                               title="Delete challan"
//                               className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-red-50 text-slate-400 hover:text-red-500 cursor-pointer"
//                             >
//                               <i className="ri-delete-bin-line text-xs" />
//                             </button>
//                           )}

//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                   {!challans.length && (
//                     <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-400">No challans yet</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {detailChallan && (
//         <ChallanDetailModal
//           challan={detailChallan}
//           onClose={() => setDetailChallan(null)}
//           onConverted={(challanId) => setChallans((prev) => prev.map((ch) => ch.id === challanId ? { ...ch, challanStatus: 'CONVERTED' as const } : ch))}
//         />
//       )}

//       <ConfirmDialog
//         open={!!deleteConfirmId}
//         title="Delete Challan?"
//         message="Remove this challan from the list? (Frontend only — API coming soon)"
//         variant="danger"
//         confirmLabel="Yes, Delete"
//         onConfirm={() => deleteConfirmId && handleDeleteChallan(deleteConfirmId)}
//         onCancel={() => setDeleteConfirmId(null)}
//       />
//     </AppLayout>
//   );
// }


import { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppLayout from '@/components/feature/AppLayout';
import ShortcutBar from '@/components/feature/ShortcutBar';
import ItemEntryTable from '@/pages/billing/components/ItemEntryTable';
import { type SelectedItem } from '@/pages/billing/components/ItemSearchInput';
import PrintChallan from '@/components/print/PrintChallan';
import ConfirmDialog from '@/components/feature/ConfirmDialog';
import ChallanDetailModal from '@/pages/sales/challans/components/ChallanDetailModal';
import { useToast } from '@/contexts/ToastContext';
import { useAuth } from '@/contexts/AuthContext';
import { MODULES } from '@/utils/permissions';
import { useKeyboardNav } from '@/utils/keyboardNav';
import { useShortcuts } from '@/hooks/useShortcuts';
import { useBillingTabStore } from '@/stores/billingTabStore';
import { emptyLineItem, type InvoiceLineItem } from '@/types/billing';
import type { MockChallanDetail } from '@/mocks/billing';
import { printChallan } from '@/utils/printDocument';
import { salesService } from '@/services/salesService';
import { isBackendAvailable } from '@/api/client';
import { filterParties, getCustomers, type PartyResponse } from '@/api/party.api';
import { filterItems, mapApiToItem, type ItemResponse } from '@/api/item.api';
import type { OutwardGPPrefill } from '@/pages/inventory/gate-pass/outward/page';
import { deleteData } from '@/services/FetchNodeServices';
import { useWarehouseStore } from '@/stores/warehouseStore';
import { useCompanyState } from '@/hooks/useCompanyState';
import { isSameStateCheck } from '@/utils/gst';
import DocumentNumberInput from '@/components/common/DocumentNumberInput';
import { getNextDocumentNumber } from '@/services/documentNumberService';

const STATUS_STYLES: Record<string, string> = {
  DRAFT: 'bg-slate-100 text-slate-600 border-slate-200',
  DISPATCHED: 'bg-amber-50 text-amber-700 border-amber-200',
  CONVERTED: 'bg-green-50 text-green-700 border-green-200',
  CANCELLED: 'bg-red-50 text-red-600 border-red-200',
};

interface Customer { id: string; name: string; address: string; stateCode?: string }
interface ItemLookup { id: string; name: string; code: string; unit: string; saleRate: number }

interface FromInvoiceState {
  invoiceId: string; invoiceNumber: string;
  customerId: string; customerName: string;
  items: Array<{
    itemId?: string; itemCode?: string; itemName: string; hsnCode: string;
    qty: number; unit: string; unitId?: string; rate: number;
    taxRate?: number; cgst?: number; sgst?: number; igst?: number;
    taxableAmount?: number; total?: number;
  }>;
}

const buildFrontendChallanNo = () => {
  return 'CH-0001';
};

// ─── CustomerSearch ───────────────────────────────────────────────────────────

function CustomerSearch({
  value, onChange, onSelect,
}: { value: string; onChange: (v: string) => void; onSelect: (c: Customer) => void }) {
  const [options, setOptions] = useState<Customer[]>([]);
  const [open, setOpen] = useState(false);
  const [highlighted, setHighlighted] = useState(-1);
  const [loading, setLoading] = useState(false);
  const { selectedWarehouseId } = useWarehouseStore();
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const abortRef = useRef<AbortController | null>(null);
  const wrapRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node))
        setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    if (highlighted < 0 || !listRef.current) return;
    const el = listRef.current.children[highlighted] as HTMLElement;
    el?.scrollIntoView({ block: 'nearest' });
  }, [highlighted]);

  // ✅ Use filterParties with server-side search — NOT getCustomers() which fetches all
  const doSearch = useCallback(async (q: string) => {
    if (!q.trim()) { setOptions([]); setOpen(false); return; }
    abortRef.current?.abort();
    abortRef.current = new AbortController();
    setLoading(true);
    try {
      const res = await filterParties({
        type: 'customer', isActive: true, search: q,
        ...(selectedWarehouseId && selectedWarehouseId !== 'ALL'
          ? { warehouse_id: selectedWarehouseId } : {}),
      });
      const mapped = (res.data ?? [])
        .filter((p: PartyResponse) => p.type === 'Customer' || p.type === 'Both')
        .map((p: PartyResponse) => ({
          id: p.id, name: p.name,
          address: p.billing_address ?? '',
          stateCode: p.state_code ?? '',
        }));

      setOptions(mapped);
      setOpen(true);
      setHighlighted(-1);
    } catch (err: any) {
      if (err?.name !== 'AbortError') setOptions([]);
    } finally {
      setLoading(false);
    }
  },
    [selectedWarehouseId],
  );

  const handleChange = (val: string) => {
    onChange(val);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!val.trim()) {
      setOptions([]);
      setOpen(false);
      return;
    }
    debounceRef.current = setTimeout(() => doSearch(val), 300);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!open || !options.length) {
      if (e.key === 'ArrowDown' && value.trim()) {
        e.preventDefault();
        doSearch(value);
      }
      return;
    }
    switch (e.key) {
      case 'ArrowDown': e.preventDefault(); setHighlighted((p) => Math.min(p + 1, options.length - 1)); break;
      case 'ArrowUp': e.preventDefault(); setHighlighted((p) => Math.max(p - 1, 0)); break;
      case 'Enter': if (highlighted >= 0) { e.preventDefault(); select(options[highlighted]); } break;
      case 'Escape': setOpen(false); break;
    }
  };

  const select = (c: Customer) => {
    onChange(c.name);
    onSelect(c);
    setOpen(false);
    setOptions([]);
  };

  return (
    <div ref={wrapRef} className="relative">
      <input
        type="text"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => {
          if (options.length) setOpen(true);
        }}
        placeholder="Search customer..."
        className="w-full h-10 px-3 text-sm bg-white border border-[#e2e8f0] rounded-lg focus:outline-none focus:border-[#4f46e5] focus:ring-2 focus:ring-indigo-100 text-[#1e293b]"
      />
      {loading && (
        <i className="ri-loader-4-line animate-spin absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
      )}

      {open && options.length > 0 && (
        <div
          ref={listRef}
          className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border border-[#e2e8f0] rounded-lg shadow-lg max-h-52 overflow-y-auto"
        >
          {options.map((c, idx) => (
            <button
              key={c.id}
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                select(c);
              }}
              onMouseEnter={() => setHighlighted(idx)}
              className={`w-full text-left px-3 py-2.5 text-sm transition-colors ${idx === highlighted ? 'bg-indigo-50 text-[#4f46e5]' : 'hover:bg-slate-50 text-[#1e293b]'}`}
            >
              <div className="font-medium">{c.name}</div>
              {c.address && (
                <div className="text-[10px] text-slate-400 truncate">
                  {c.address}
                </div>
              )}
            </button>
          ))}
        </div>
      )}
      {open && !loading && options.length === 0 && value.trim() && (
        <div className="absolute z-50 left-0 right-0 top-full mt-1 bg-white border border-[#e2e8f0] rounded-lg shadow-sm px-3 py-3 text-xs text-slate-400">
          No customers found
        </div>
      )}
    </div>
  );
}

import { jobWorkService } from '@/services/jobWorkService';
import { carryLineUnit } from '@/hooks/useUnits';

// ─── ChallansPage ─────────────────────────────────────────────────────────────

export default function ChallansPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const headerRef = useRef<HTMLDivElement>(null);
  useKeyboardNav(headerRef as React.RefObject<HTMLElement>);
  const { addTabWithChallan } = useBillingTabStore();

  const { hasPermission, hasControl } = useAuth();
  const canCreate = hasPermission(MODULES.CHALLAN, 'create');
  const canUpdate = hasPermission(MODULES.CHALLAN, 'edit');
  const canDelete = hasPermission(MODULES.CHALLAN, 'delete');
  const canConvert = hasPermission(MODULES.SALES_INVOICE, 'create') || hasControl('convertChallan');

  const [mode, setMode] = useState<'list' | 'new'>('list');
  const [challans, setChallans] = useState<MockChallanDetail[]>([]);
  const [detailChallan, setDetailChallan] = useState<MockChallanDetail | null>(null);
  const [editingChallanId, setEditingChallanId] = useState<string | null>(null);
  const [deleteConfirmId, setDeleteConfirmId] = useState<string | null>(null);
  const [fromInvoiceBadge, setFromInvoiceBadge] = useState<string | null>(null);
  const [fromSOBadge, setFromSOBadge] = useState<string | null>(null);
  const [fromJWOBadge, setFromJWOBadge] = useState<string | null>(null);
  const [fromJWOId, setFromJWOId] = useState<string | null>(null);

  const [orderMode, setOrderMode] = useState<'manual' | 'order_all' | 'order' | 'job_work'>('manual');
  const [subContractorsList, setSubContractorsList] = useState<any[]>([]);
  const [customerQuery, setCustomerQuery] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [challanNo, setChallanNo] = useState('');
  const [loadingChallanNo, setLoadingChallanNo] = useState(false);
  const [vehicleNo, setVehicleNo] = useState('');
  const [driverName, setDriverName] = useState('');
  const [lrNo, setLrNo] = useState('');
  const [items, setItems] = useState<InvoiceLineItem[]>([emptyLineItem()]);
  const [saving, setSaving] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [loadingChallans, setLoadingChallans] = useState(false);
  const [itemLookup, setItemLookup] = useState<ItemLookup[]>([]);

  const companyStateCode = useCompanyState();
  const { selectedWarehouseId: warehouseId, selectedWarehouseName, selectedWarehouseAddress, selectedWarehouseGstin } = useWarehouseStore();
  const isSameState = isSameStateCheck(selectedCustomer?.stateCode ?? '', companyStateCode);

  // Fetch dedicated Sub-Contractors for Against Job Work Order mode
  useEffect(() => {
    jobWorkService.getSubContractors({ warehouseId }).then((list) => {
      setSubContractorsList(list || []);
    });
  }, [warehouseId]);

  type PendingOrderItem = {
    id: string; itemId: string; itemCode: string; itemName: string; hsnCode: string;
    qty: number; orderedQty?: number; pendingQty?: number; unit: string; rate: number; discount: number; taxRate: number;
    taxableAmount: number; cgst: number; sgst: number; igst: number; total: number;
  };
  type PendingOrder = { id: string; orderNo: string; date: string; grandTotal: number; items: PendingOrderItem[] };
  type PendingInvoice = { id: string; invoiceNo: string; date: string; paymentStatus: string; grandTotal: number; balanceDue: number; items: PendingOrderItem[] };

  const [pendingOrders, setPendingOrders] = useState<PendingOrder[]>([]);
  const [pendingInvoices, setPendingInvoices] = useState<PendingInvoice[]>([]);
  const [loadingPending, setLoadingPending] = useState(false);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState<string[]>([]);

  // Allowed items in order mode
  const allowedItems = useMemo<SelectedItem[] | undefined>(() => {
    if (!selectedCustomer || (orderMode !== 'order' && orderMode !== 'order_all')) return undefined;
    const seen = new Set<string>();
    const list: SelectedItem[] = [];
    for (const o of pendingOrders) {
      for (const item of o.items) {
        if (!item.itemId || seen.has(item.itemId)) continue;
        seen.add(item.itemId);
        list.push({
          id: item.itemId, name: item.itemName, code: item.itemCode || '',
          hsnCode: item.hsnCode || '', taxRate: Number(item.taxRate ?? 18),
          purchaseRate: Number(item.rate ?? 0), saleRate: Number(item.rate ?? 0),
          currentStock: Number(item.qty ?? 0), unit: item.unit || 'Pcs',
          unitId: '', isActive: true,
        });
      }
    }
    return list;
  }, [selectedCustomer, orderMode, pendingOrders]);

  // Pending orders fetch
  useEffect(() => {
    if ((orderMode !== 'order' && orderMode !== 'order_all') || !selectedCustomer?.id) { setPendingOrders([]); setSelectedInvoiceIds([]); return; }
    let mounted = true; setLoadingPending(true);
    salesService.getCustomerPendingOrders(selectedCustomer.id)
      .then((data) => { if (mounted) setPendingOrders(data.map((o: any) => ({ id: o.id, orderNo: o.invoiceNo || o.orderNo, date: o.date, grandTotal: o.grandTotal, items: o.items || [] }))); })
      .catch(() => { if (mounted) setPendingOrders([]); })
      .finally(() => { if (mounted) setLoadingPending(false); });
    return () => { mounted = false; };
  }, [orderMode, selectedCustomer?.id]);

  // Pending invoices fetch
  useEffect(() => {
    if (orderMode !== 'manual' || !selectedCustomer?.id) { setPendingInvoices([]); return; }
    let mounted = true; setLoadingPending(true);
    salesService.getCustomerPendingInvoices(selectedCustomer.id)
      .then((data) => { if (mounted) setPendingInvoices(data.map((inv: any) => ({ id: inv.id, invoiceNo: inv.invoiceNo, date: inv.date, paymentStatus: inv.paymentStatus, grandTotal: inv.grandTotal, balanceDue: inv.balanceDue, items: inv.items || [] }))); })
      .catch(() => { if (mounted) setPendingInvoices([]); })
      .finally(() => { if (mounted) setLoadingPending(false); });
    return () => { mounted = false; };
  }, [orderMode, selectedCustomer?.id]);

  const toggleInvoiceSelection = (id: string) => {
    setSelectedInvoiceIds((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      const updatedItems: InvoiceLineItem[] = [];
      const isOrderMode = orderMode === 'order' || orderMode === 'order_all';
      const source = isOrderMode ? pendingOrders : pendingInvoices;
      source.forEach((doc: any) => {
        if (!next.includes(doc.id)) return;
        doc.items.forEach((it: PendingOrderItem) => {
          let itemQty = 1;
          if (orderMode === 'order') {
            itemQty = (it.pendingQty != null && it.pendingQty > 0) ? it.pendingQty : (it.qty > 0 ? it.qty : 1);
          } else if (orderMode === 'order_all') {
            itemQty = (it.orderedQty != null && it.orderedQty > 0) ? it.orderedQty : (it.qty > 0 ? it.qty : 1);
          } else {
            itemQty = it.qty > 0 ? it.qty : 1;
          }
          updatedItems.push({
            ...emptyLineItem(), id: crypto.randomUUID(),
            itemId: it.itemId, itemCode: it.itemCode, itemName: it.itemName,
            hsnCode: it.hsnCode, qty: itemQty,
            unit: it.unit || 'Pcs', rate: it.rate, discount: it.discount,
            taxRate: it.taxRate, taxableAmount: it.taxableAmount,
            cgst: it.cgst, sgst: it.sgst, igst: it.igst, total: it.total,
            invoiceId: doc.id,
            invoiceNo: isOrderMode ? doc.orderNo : doc.invoiceNo,
            salesOrderId: isOrderMode ? doc.id : undefined,
          });
        });
      });
      setItems(updatedItems.length > 0 ? updatedItems : [emptyLineItem()]);
      return next;
    });
  };

  const resetForm = useCallback(() => {
    setEditingChallanId(null); setCustomerQuery(''); setSelectedCustomer(null);
    setDate(new Date().toISOString().slice(0, 10));
    setVehicleNo(''); setDriverName(''); setLrNo('');
    setItems([emptyLineItem()]); setFromInvoiceBadge(''); setFromSOBadge('');
    setSelectedInvoiceIds([]); setSelectedOrderId(''); setOrderMode('manual');
  }, []);

  const fetchNextChallanNo = useCallback(async () => {
    setLoadingChallanNo(true);
    try {
      const res = await getNextDocumentNumber('DELIVERY_CHALLAN', warehouseId || undefined);
      if (res?.data?.nextNumber) {
        setChallanNo(res.data.nextNumber);
      } else {
        setChallanNo(buildFrontendChallanNo());
      }
    } catch (err) {
      console.error('Failed to fetch next challan number:', err);
      setChallanNo(buildFrontendChallanNo());
    } finally {
      setLoadingChallanNo(false);
    }
  }, [warehouseId]);

  useEffect(() => {
    if (mode === 'new' && !editingChallanId) {
      void fetchNextChallanNo();
    }
  }, [mode, warehouseId, editingChallanId, fetchNextChallanNo]);

  // ✅ KEY FIX: auto-open new form when navigated from invoice list with fromInvoice state
  useEffect(() => {
    const state = location.state as { fromInvoice?: FromInvoiceState } | null;
    if (!state?.fromInvoice) return;
    const inv = state.fromInvoice;

    // Switch to new mode and pre-fill everything
    setMode('new');
    setOrderMode('manual');
    setFromInvoiceBadge(inv.invoiceNumber);
    setCustomerQuery(inv.customerName);
    setSelectedCustomer({ id: inv.customerId, name: inv.customerName, address: '', stateCode: '' });
    setSelectedInvoiceIds([inv.invoiceId]);

    // Pre-fill items from the invoice
    setItems(inv.items.map((i) => ({
      ...emptyLineItem(),
      itemId: i.itemId ?? '',
      itemCode: i.itemCode ?? '',
      itemName: i.itemName,
      hsnCode: i.hsnCode ?? '',
      qty: i.qty > 0 ? i.qty : 1,
      unit: i.unit,
      unitId: i.unitId ?? '',
      rate: i.rate,
      taxRate: i.taxRate ?? 0,
      cgst: i.cgst ?? 0,
      sgst: i.sgst ?? 0,
      igst: i.igst ?? 0,
      taxableAmount: i.taxableAmount ?? (i.qty * i.rate),
      total: i.total ?? (i.qty * i.rate),
      invoiceId: inv.invoiceId,
      invoiceNo: inv.invoiceNumber,
    })));

    // Clear navigation state after a tick so items are set first
    setTimeout(() => navigate(location.pathname, { replace: true, state: null }), 100);
  }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

  // ✅ KEY FIX: auto-open new form when navigated from Sales Order with fromSalesOrder state
  useEffect(() => {
    const state = location.state as { fromSalesOrder?: any } | null;
    if (!state?.fromSalesOrder) return;
    const so = state.fromSalesOrder;

    setMode('new');
    setOrderMode('order');
    setFromSOBadge(so.soNumber);
    setCustomerQuery(so.customerName);
    setSelectedCustomer({ id: so.customerId, name: so.customerName, address: '' });
    setSelectedOrderId(so.soId);
    setSelectedInvoiceIds([so.soId]);

    setItems((so.items || []).filter((i: any) => (i.pendingQty !== undefined ? i.pendingQty > 0 : true)).map((i: any) => {
      const lineQty = (i.pendingQty && i.pendingQty > 0) ? i.pendingQty : (i.qty && i.qty > 0 ? i.qty : 1);
      const lineTaxable = lineQty * (i.rate || 0) * (1 - (i.discount || 0) / 100);
      return {
        ...emptyLineItem(),
        id: crypto.randomUUID(),
        itemId: i.itemId ?? '',
        itemCode: i.itemCode ?? '',
        itemName: i.itemName,
        hsnCode: i.hsnCode ?? '',
        qty: lineQty,
        unit: i.unit || 'Pcs',
        unitId: i.unitId ?? '',
        rate: i.rate ?? 0,
        discount: i.discount ?? 0,
        taxRate: i.taxRate ?? 0,
        taxableAmount: lineTaxable,
        total: lineTaxable * (1 + (i.taxRate || 0) / 100),
        salesOrderId: so.soId,
        soNumber: so.soNumber,
      };
    }));

    setTimeout(() => navigate(location.pathname, { replace: true, state: null }), 100);
  }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-open new form when navigated from Job Work Order with fromJWO state
  useEffect(() => {
    const state = location.state as { fromJWO?: any } | null;
    if (!state?.fromJWO) return;
    const jwo = state.fromJWO;

    setMode('new');
    setOrderMode('job_work');
    setFromJWOBadge(jwo.jwoNumber || jwo.jwo_number || jwo.id);
    setFromJWOId(jwo.id);
    setCustomerQuery(jwo.subContractorName || jwo.sub_contractor_name || '');
    setSelectedCustomer({
      id: jwo.subContractorId || jwo.sub_contractor_id || 'sub-contractor',
      name: jwo.subContractorName || jwo.sub_contractor_name || 'Sub-Contractor',
      address: '',
      stateCode: ''
    });

    const rawItems = jwo.items || [];
    setItems(rawItems.map((i: any) => ({
      ...emptyLineItem(),
      id: crypto.randomUUID(),
      itemId: i.itemId || i.item_id || '',
      itemCode: i.itemCode || i.item_code || '',
      itemName: i.itemName || i.item_name || 'Item',
      hsnCode: i.hsnCode || i.hsn_code || '',
      qty: Number(i.sentQty || i.sent_qty || i.qty || 1),
      unit: i.unit || 'Pcs',
      unitId: i.unitId || '',
      rate: Number(i.rate || 0),
      discount: 0,
      taxRate: Number(i.taxRate || i.tax_rate || 0),
      taxableAmount: Number(i.rate || 0) * Number(i.sentQty || i.sent_qty || i.qty || 1),
      total: Number(i.rate || 0) * Number(i.sentQty || i.sent_qty || i.qty || 1),
    })));

    setTimeout(() => navigate(location.pathname, { replace: true, state: null }), 100);
  }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-open challan detail when navigated from invoice list with openChallanNo
  useEffect(() => {
    const state = location.state as { openChallanNo?: string } | null;
    if (!state?.openChallanNo) return;
    const targetNo = state.openChallanNo;

    // Wait until challan list is loaded then find and open the matching one
    const tryOpen = async () => {
      // Find by billNo (challan_number mapped as invoiceNo → billNo in the list)
      const found = challans.find(
        (c) => c.billNo === targetNo
      );
      if (found) {
        const d = await loadChallanDetail(found.id);
        if (d) setDetailChallan(d);
        navigate(location.pathname, { replace: true, state: null });
      }
    };

    if (challans.length > 0) {
      void tryOpen();
    }
    // If challans not loaded yet, the effect will re-run when challans change
  }, [location.state, challans]); // eslint-disable-line react-hooks/exhaustive-deps

  // Load challan list + items
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      if (mounted) setLoadingChallans(true);
      try {
        const [challansResult, itemsResult] = await Promise.allSettled([
          isBackendAvailable()
            ? salesService.listChallans({ page: 1, limit: 200, warehouseId })
            : Promise.resolve(null),
          filterItems({}),
        ]);
        if (!mounted) return;

        // In the useEffect that loads challans
        if (challansResult.status === 'fulfilled' && challansResult.value) {
          setChallans(challansResult.value.items.map((row: any) => ({
            id: row.id, billNo: row.invoiceNo, date: row.date,
            createdAt: row.createdAt,
            partyName: row.partyName || '—',
            warehouseName: row.warehouseName || '—',
            itemCount: row.itemCount || 0,
            grandTotal: row.grandTotal || 0,
            status: row.status || 'SAVED',
            challanStatus: row.status || 'DISPATCHED',
            linkedInvoiceNumber: row.linkedInvoiceNumber,
            linkedInvoiceStatus: row.linkedInvoiceStatus,
            vehicleNo: row.vehicleNo || '', driverName: row.driverName || '',
            lrNo: row.lrNo || '', billingAddress: row.billingAddress || '',
            items: row.items || [],
            sourceInvoiceId: row.sourceInvoiceId || null,
            hasSourceInvoice: row.hasSourceInvoice || row.sourceInvoiceId != null || false,
          })));
        }

        if (itemsResult.status === 'fulfilled') {
          setItemLookup(
            (itemsResult.value.data ?? []).map((row: ItemResponse) => {
              const item = mapApiToItem(row);
              return {
                id: item.id,
                name: item.name,
                code: item.code,
                unit: item.unitName || 'Pcs',
                saleRate: item.saleRate,
              };
            }),
          );
        }
      } finally { if (mounted) setLoadingChallans(false); }
    };
    void loadData();
    return () => { mounted = false; };
  }, [warehouseId]);

  const loadChallanDetail = useCallback(async (challanId: string): Promise<MockChallanDetail | null> => {
    try {
      const d = await salesService.getChallan(challanId);
      return {
        id: d.id, billNo: d.invoiceNo, date: d.date,
        customerId: d.customerId, warehouseId: d.warehouseId,
        partyName: d.partyName || '—', warehouseName: d.warehouseName || '—',
        warehouseAddress: (d as any).warehouseAddress || '',
        warehouseGstin: (d as any).warehouseGstin || '',
        itemCount: d.itemCount || 0, grandTotal: d.grandTotal || 0,
        status: (d.status as MockChallanDetail['status']) || 'SAVED',
        challanStatus: (d.status as MockChallanDetail['challanStatus']) || 'DISPATCHED',
        linkedInvoiceNumber: d.linkedInvoiceNumber,
        linkedInvoiceStatus: d.linkedInvoiceStatus,
        hasSourceInvoice: d.hasSourceInvoice || false,
        sourceInvoiceId: d.sourceInvoiceId || null,
        vehicleNo: d.vehicleNo || '', driverName: d.driverName || '',
        lrNo: d.lrNo || '', billingAddress: d.billingAddress || '',
        items: ((d.items as any[]) ?? []).map((item: any, idx: number) => ({
          id: item.id || `dci-${idx}`, itemId: item.itemId, itemName: item.itemName,
          qty: Number(item.qty || 0), unit: item.unit || 'Pcs',
          rate: item.rate, amount: item.amount, hsnCode: item.hsnCode,
          taxRate: item.taxRate, cgst: item.cgst, sgst: item.sgst,
          igst: item.igst, taxableAmount: item.taxableAmount,
          batchId: item.batchId,
          batchNumber: item.batchNumber,
          serialNumbers: item.serialNumbers,
          serials: item.serials,
        })),
      };
    } catch { toast.error('Failed to load challan details'); return null; }
  }, [toast]);

  const resolveItemIdentity = useCallback((row: InvoiceLineItem): InvoiceLineItem => {
    if (row.itemId) return row;
    const qName = row.itemName.trim().toLowerCase();
    const qCode = row.itemCode.trim().toLowerCase();
    const found = itemLookup.find((item) =>
      (qName && item.name.trim().toLowerCase() === qName) ||
      (qCode && item.code.trim().toLowerCase() === qCode),
    );
    if (!found) return row;
    return { ...row, itemId: found.id, itemCode: row.itemCode || found.code, itemName: row.itemName || found.name, unit: row.unit || found.unit, rate: row.rate || found.saleRate };
  }, [itemLookup]);

  const handleGenerateOutwardGPFromChallan = async (challan: MockChallanDetail) => {
    let detail = challan;
    if (!challan.items?.length) {
      try {
        const fetched = await salesService.getChallan(challan.id);
        detail = {
          ...challan, id: fetched.id, billNo: fetched.invoiceNo || challan.billNo, partyName: fetched.partyName || challan.partyName,
          items: (fetched.items ?? []).map((item: any, idx: number) => ({
            id: item.id || `${challan.id}-item-${idx}`,
            itemName: String(item.itemName || item.item_name || '—'),
            qty: Number(item.qty || item.quantity || 0), unit: String(item.unit || item.unitName || 'Pcs'),
            rate: Number(item.rate || 0), amount: Number(item.amount || 0),
          })),
        };
      } catch { toast.error('Failed to load challan details'); return; }
    }
    const prefill: OutwardGPPrefill = {
      partyName: detail.partyName, linkedDocType: 'CHALLAN', linkedDocNumber: detail.id,
      notes: `Generated from Challan ${detail.billNo}`,
      items: (detail.items || []).map((i) => ({ itemName: i.itemName, qty: i.qty, unit: i.unit || 'Pcs', description: `${i.itemName} - Qty: ${i.qty}` })),
    };
    navigate('/inventory/gate-pass/outward', { state: { prefill } });
  };

  const handleEditChallan = useCallback(async (challan: MockChallanDetail) => {
    try {
      const detail = await salesService.getChallan(challan.id);
      const rawItems = (detail.items as any[]) ?? [];
      setEditingChallanId(challan.id);
      setChallanNo(detail.invoiceNo || challan.billNo || '');
      setCustomerQuery(detail.partyName || challan.partyName);
      setSelectedCustomer({ id: (detail as any).customerId || (detail as any).customer_id || '', name: detail.partyName || challan.partyName, address: (detail as any).billingAddress || challan.billingAddress || '' });
      setDate(detail.date || challan.date);
      setVehicleNo(detail.vehicleNo || challan.vehicleNo || '');
      setDriverName(detail.driverName || challan.driverName || '');
      setLrNo(detail.lrNo || challan.lrNo || '');
      setItems(rawItems.length > 0 ? rawItems.map((item: any) => ({
        ...emptyLineItem(), itemId: item.itemId ?? '', itemCode: '',
        itemName: item.itemName ?? item.item_name ?? '', hsnCode: item.hsnCode ?? item.hsn_code ?? '',
        unit: item.unit ?? item.unitName ?? 'Pcs',
        // As entered when another unit than the stock unit was used
        ...carryLineUnit({ qty: Number(item.qty ?? item.quantity ?? 1), rate: Number(item.rate ?? 0), enteredQty: item.enteredQty, enteredUnitId: item.enteredUnitId, enteredRate: item.enteredRate }),
        taxRate: Number(item.taxRate ?? 0),
        cgst: Number(item.cgst ?? 0), sgst: Number(item.sgst ?? 0), igst: Number(item.igst ?? 0),
        taxableAmount: Number(item.taxableAmount ?? 0),
      })) : [emptyLineItem()]);
      setMode('new');
    } catch { toast.error('Failed to load challan for editing'); }
  }, [toast]);

  const handleDeleteChallan = async (id: string) => {
    try {
      const res = await deleteData(`api/v1/challans/${id}`);
      if (res.success) {
        setChallans((prev) => prev.filter((c) => c.id !== id));
        toast.success('Challan deleted');
        setDeleteConfirmId(null);
      } else {
        toast.error(res.message || 'Failed to delete challan');
      }
    } catch { toast.error('Network error deleting challan'); }
  };

  const handleSave = useCallback(async (andNew = false) => {
    if (!selectedCustomer) { toast.error('Select a customer'); return; }
    if (!warehouseId) { toast.error('Select a warehouse'); return; }
    if (!selectedCustomer.id) { toast.error('Customer selection is invalid. Please re-select.'); return; }
    const validItems = items.filter((i) => i.itemName && i.qty > 0);
    if (!validItems.length) { toast.error('Add at least one item'); return; }
    const normalizedItems = validItems.map(resolveItemIdentity);
    const unresolved = normalizedItems.filter((i) => !i.itemId);
    if (unresolved.length) { toast.error(`Select valid item from dropdown for: ${unresolved[0].itemName}`); return; }

    setSaving(true);
    await new Promise((r) => setTimeout(r, 300));

    let newChallan: MockChallanDetail = {
      id: editingChallanId ?? `dc-new-${Date.now()}`,
      billNo: challanNo || 'Auto Generated', date,
      partyName: selectedCustomer.name, warehouseName: '—',
      itemCount: normalizedItems.length,
      grandTotal: Number(normalizedItems.reduce((s, i) => s + i.qty * i.rate, 0).toFixed(2)),
      status: 'SAVED', challanStatus: 'DISPATCHED',
      hasSourceInvoice: !!fromInvoiceBadge,
      linkedInvoiceNumber: fromInvoiceBadge || null,
      vehicleNo, driverName, lrNo, billingAddress: selectedCustomer.address,
      items: normalizedItems.map((i, idx) => ({
        id: `dci-new-${idx}`, itemId: i.itemId, itemCode: i.itemCode, itemName: i.itemName,
        hsnCode: i.hsnCode, qty: i.qty, unit: i.unit, unitId: i.unitId,
        rate: i.rate, amount: i.qty * i.rate, taxRate: i.taxRate,
        cgst: i.cgst, sgst: i.sgst, igst: i.igst, taxableAmount: i.taxableAmount,
      })),
    };

    const challanPayload = {
      customerId: selectedCustomer.id, warehouseId, date, vehicleNo, driverName, lrNo,
      challanNo: challanNo?.trim() || undefined,
      challanNumber: challanNo?.trim() || undefined,
      salesOrderId: selectedOrderId || (items.find(i => (i as any).salesOrderId)?.salesOrderId) || null,
      sourceInvoiceId: selectedInvoiceIds.length === 1 && orderMode !== 'order' ? selectedInvoiceIds[0] : null,
      items: normalizedItems.map((i) => ({
        itemId: i.itemId, qty: Number(i.qty || 0), unit: i.unit || 'Pcs',
        // qty and rate are in this unit; the server converts them to the stock unit
        enteredUnitId: i.enteredUnitId || undefined,
        rate: Number(i.rate || 0), taxRate: Number(i.taxRate || 0),
        taxableAmount: Number(i.taxableAmount || i.qty * i.rate),
        cgst: Number(i.cgst || 0), sgst: Number(i.sgst || 0), igst: Number(i.igst || 0),
        invoiceId: i.invoiceId || null,
        salesOrderId: (i as any).salesOrderId || selectedOrderId || null,
      })),
    };

    if (isBackendAvailable()) {
      try {
        const saved = editingChallanId
          ? await salesService.updateChallan(editingChallanId, challanPayload)
          : await salesService.createChallan(challanPayload);
        newChallan = {
          ...newChallan, id: saved.id, billNo: saved.invoiceNo, date: saved.date,
          partyName: saved.partyName || newChallan.partyName,
          warehouseName: saved.warehouseName || newChallan.warehouseName,
          itemCount: saved.itemCount || newChallan.itemCount,
          grandTotal: saved.grandTotal || newChallan.grandTotal,
          status: (saved.status as MockChallanDetail['status']) || newChallan.status,
          challanStatus: (saved.status as MockChallanDetail['challanStatus']) || newChallan.challanStatus,
        };
      } catch (error) {
        toast.error(error instanceof Error ? error.message : 'Failed to save challan');
        setSaving(false); return;
      }
    }

    if (fromJWOId) {
      try {
        await jobWorkService.issueChallan(fromJWOId);
        toast.success(`Job Work Order status updated to ISSUED!`);
      } catch (err) {
        console.error('Error updating Job Work Order status:', err);
      } finally {
        setFromJWOId(null);
        setFromJWOBadge(null);
      }
    }

    setChallans((prev) => editingChallanId ? prev.map((c) => c.id === editingChallanId ? newChallan : c) : [newChallan, ...prev]);
    setSaving(false);
    toast.success(editingChallanId ? `Challan ${newChallan.billNo} updated!` : `Challan ${newChallan.billNo} saved!`);

    if (andNew) {
      setItems([emptyLineItem()]); setSelectedCustomer(null); setCustomerQuery('');
      setVehicleNo(''); setDriverName(''); setLrNo(''); setSelectedOrderId(''); setEditingChallanId(null);
      void fetchNextChallanNo();
    } else {
      setEditingChallanId(null); setMode('list');
    }
  }, [selectedCustomer, warehouseId, items, challanNo, date, vehicleNo, driverName, lrNo, editingChallanId, toast, resolveItemIdentity, fetchNextChallanNo, selectedOrderId, selectedInvoiceIds, orderMode]);

  useShortcuts('challan-new', { F8: () => handleSave(true), F9: () => handleSave(false), F10: () => setPrintOpen(true), Escape: () => setMode('list') });

  const buildPrintData = () => ({
    challanNo: challanNo || 'Auto Generated', date,
    customerName: selectedCustomer?.name ?? '—',
    billingAddress: selectedCustomer?.address ?? '',
    vehicleNo, driverName, lrNo,
    warehouseName: selectedWarehouseName,
    warehouseAddress: selectedWarehouseAddress,
    warehouseGstin: selectedWarehouseGstin,
    items: items.filter((i) => i.itemName).map((i: any, idx) => ({
      sr: idx + 1,
      name: i.itemName,
      qty: i.qty,
      unit: i.unit,
      rate: i.rate,
      amount: i.amount || (i.qty * (i.rate || 0)),
      batchNumber: i.batchNumber,
      serialNumbers: i.serialNumbers,
      serials: i.serials,
    })),
  });

  // Shared doc table renderer
  const renderDocTable = (docs: any[], noField: string, label: string) =>
    docs.length === 0 ? (
      <p className="text-sm text-[#94a3b8] mt-2">No pending {label} for this customer</p>
    ) : (
      <div className="overflow-x-auto border border-[#e2e8f0] rounded-lg mt-2 shadow-sm" style={{ maxHeight: '30vh' }}>
        <table className="min-w-full divide-y divide-[#e2e8f0]">
          <thead className="bg-slate-50 sticky top-0">
            <tr>
              {[`${label} No`, 'Date', 'Customer', 'Amount', 'Select'].map((h) => (
                <th key={h} className="px-4 py-2.5 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider last:text-center">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-[#e2e8f0]">
            {docs.map((doc) => {
              const isChecked = selectedInvoiceIds.includes(doc.id);
              return (
                <tr key={doc.id} className={`hover:bg-slate-50 transition-colors ${isChecked ? 'bg-indigo-50/30' : ''}`}>
                  <td className="px-4 py-3 text-sm font-semibold text-[#4f46e5]">{doc[noField]}</td>
                  <td className="px-4 py-3 text-sm text-slate-600">{new Date(doc.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                  <td className="px-4 py-3 text-sm text-slate-700 font-medium">{selectedCustomer?.name}</td>
                  <td className="px-4 py-3 text-sm text-slate-800 font-semibold">₹{doc.grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                  <td className="px-4 py-3 text-center">
                    <button type="button" onClick={() => toggleInvoiceSelection(doc.id)}
                      className={`w-6 h-6 rounded-md flex items-center justify-center mx-auto transition-all border ${isChecked ? 'bg-indigo-600 border-indigo-600 text-white shadow-sm' : 'bg-white border-slate-300 text-transparent hover:border-indigo-500'}`}
                    >
                      <i className="ri-check-line text-sm font-bold" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );

  const fl = 'w-full h-10 px-3 text-sm bg-white border border-[#e2e8f0] rounded-lg focus:outline-none focus:border-[#4f46e5] focus:ring-2 focus:ring-indigo-100 text-[#1e293b]';
  const lb = 'block text-xs font-semibold text-slate-500 mb-1';

  // ─── NEW / EDIT VIEW ───────────────────────────────────────────────────────
  if (mode === 'new') return (
    <AppLayout>
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-y-auto p-6 pb-16 bg-[#f8fafc]">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="flex items-center gap-3">
                <h1 className="text-lg font-bold text-[#1e293b]">{editingChallanId ? 'Edit Delivery Challan' : 'New Delivery Challan'}</h1>
                {fromInvoiceBadge && (
                  <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 font-medium">
                    <i className="ri-file-list-3-line" /> Pre-filled from Invoice: {fromInvoiceBadge}
                  </span>
                )}
                {fromSOBadge && (
                  <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 font-medium">
                    <i className="ri-shopping-bag-3-line" /> Pre-filled from Sales Order: {fromSOBadge}
                  </span>
                )}
                {fromJWOBadge && (
                  <span className="flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full bg-blue-50 text-blue-700 border border-blue-200 font-medium">
                    <i className="ri-tools-line" /> Pre-filled from Job Work Order: {fromJWOBadge}
                  </span>
                )}
              </div>
              <p className="text-sm text-slate-500">
                {loadingChallanNo ? 'Fetching challan number...' : challanNo ? `${challanNo} — No stock movement on save` : 'Challan No. will be auto-generated on save'}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => handleSave(true)} disabled={saving} className="flex items-center gap-1.5 h-9 px-3 rounded-lg border border-[#e2e8f0] text-sm font-medium text-[#64748b] hover:bg-[#f1f5f9] disabled:opacity-50 cursor-pointer whitespace-nowrap">
                <i className="ri-save-line text-xs" /> Save & New <kbd className="text-[10px] bg-[#e2e8f0] px-1 rounded ml-0.5">F8</kbd>
              </button>
              <button onClick={() => handleSave(false)} disabled={saving} className="flex items-center gap-1.5 h-9 px-4 rounded-lg bg-[#4f46e5] text-white text-sm font-semibold hover:bg-indigo-700 disabled:opacity-60 cursor-pointer whitespace-nowrap">
                {saving ? <><i className="ri-loader-4-line animate-spin" /> Saving...</> : <><i className="ri-save-3-line" /> Save <kbd className="text-[10px] bg-white/20 px-1 rounded ml-0.5">F9</kbd></>}
              </button>
            </div>
          </div>

          <div className="bg-white border border-[#e2e8f0] rounded-xl p-4 mb-4">
            <div className="flex flex-wrap items-center gap-6">
              {[
                { id: 'manual', label: 'Without Order', desc: '' },
                // { id: 'order_all', label: 'Against Sales Order', desc: '(fetch items from order)' },
                { id: 'order', label: 'Against Pending Order', desc: '(fetch pending items from SO)' },
                { id: 'job_work', label: 'Against Job Work Order', desc: '(for sub-contractors)' },
              ].map((m) => (
                <label key={m.id} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="orderMode"
                    value={m.id}
                    checked={orderMode === m.id}
                    onChange={() => {
                      setOrderMode(m.id as any);
                      setSelectedOrderId('');
                      setSelectedInvoiceIds([]);
                      setItems([emptyLineItem()]);
                    }}
                    className="w-4 h-4 text-[#4f46e5] border-slate-300 focus:ring-[#4f46e5] cursor-pointer"
                  />
                  <span className="text-sm font-medium text-[#1e293b]">{m.label}</span>
                  {m.desc && <span className="text-xs text-[#94a3b8]">{m.desc}</span>}
                </label>
              ))}
            </div>
          </div>

          <div ref={headerRef} className="bg-white border border-[#e2e8f0] rounded-xl p-5 mb-4">
            <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-4">Challan Details</h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {orderMode === 'job_work' ? (
                <div className="lg:col-span-2">
                  <label className={lb}>Sub-Contractor <span className="text-red-500">*</span></label>
                  <select
                    value={selectedCustomer?.id || ''}
                    onChange={(e) => {
                      const subId = e.target.value;
                      const found = subContractorsList.find((s) => s.id === subId);
                      if (found) {
                        setSelectedCustomer({ id: found.id, name: found.name, address: found.address || '', stateCode: found.state || '' });
                        setCustomerQuery(found.name);
                      } else {
                        setSelectedCustomer(null);
                        setCustomerQuery('');
                      }
                    }}
                    className={fl}
                  >
                    <option value="">Select Sub-Contractor...</option>
                    {subContractorsList.map((sub) => (
                      <option key={sub.id} value={sub.id}>
                        {sub.name} {sub.gstin ? `(${sub.gstin})` : ''} {sub.city ? `— ${sub.city}` : ''}
                      </option>
                    ))}
                    {selectedCustomer && !subContractorsList.some((s) => s.id === selectedCustomer.id) && (
                      <option value={selectedCustomer.id}>
                        {selectedCustomer.name}
                      </option>
                    )}
                  </select>
                </div>
              ) : (
                <div className="lg:col-span-2">
                  <label className={lb}>Customer <span className="text-red-500">*</span></label>
                  <CustomerSearch value={customerQuery} onChange={setCustomerQuery}
                    onSelect={(c) => { setSelectedCustomer(c); setCustomerQuery(c.name); setSelectedOrderId(''); setSelectedInvoiceIds([]); setItems([emptyLineItem()]); }} />
                </div>
              )}
              <div>
                <label className={lb}>Date</label>
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className={fl} />
              </div>
              <div>
                <DocumentNumberInput
                  value={challanNo}
                  onChange={setChallanNo}
                  label="Challan No"
                  disabled={loadingChallanNo}
                />
              </div>
              <div><label className={lb}>Vehicle No</label><input value={vehicleNo} onChange={(e) => setVehicleNo(e.target.value)} className={fl} placeholder="MH-12-AB-1234" /></div>
              <div><label className={lb}>Driver Name</label><input value={driverName} onChange={(e) => setDriverName(e.target.value)} className={fl} placeholder="Driver name" /></div>
              <div><label className={lb}>LR No</label><input value={lrNo} onChange={(e) => setLrNo(e.target.value)} className={fl} placeholder="Lorry receipt no" /></div>
            </div>

            {selectedCustomer && (
              <div className="mt-4 pt-4 border-t border-[#e2e8f0]">
                <label className={lb}>
                  {orderMode === 'order' ? `Pending Sales Orders for ${selectedCustomer.name}` : `Pending Invoices for ${selectedCustomer.name}`}
                </label>
                {loadingPending ? (
                  <p className="text-sm text-slate-500 flex items-center gap-1.5 mt-2">
                    <i className="ri-loader-4-line animate-spin text-[#4f46e5]" />
                    {orderMode === 'order' ? 'Loading pending orders...' : 'Loading pending invoices...'}
                  </p>
                ) : orderMode === 'order'
                  ? renderDocTable(pendingOrders, 'orderNo', 'Invoice')
                  : renderDocTable(pendingInvoices, 'invoiceNo', 'Invoice')}
              </div>
            )}
          </div>

          <div className="bg-white border border-[#e2e8f0] rounded-xl p-5">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-wide">Items</h2>
              <span className="text-xs text-slate-400">No stock movement — challan is for dispatch only</span>
            </div>
            <ItemEntryTable items={items} onChange={setItems} isSameState={isSameState} warehouseId={warehouseId} rateType="sale" allowedItems={allowedItems} />
          </div>
        </div>

        {printOpen && <PrintChallan data={buildPrintData()} onClose={() => setPrintOpen(false)} onPrint={() => printChallan(buildPrintData())} />}
        <ShortcutBar onSave={() => handleSave(false)} onSaveAndNew={() => handleSave(true)} onPrint={() => setPrintOpen(true)} onBack={() => setMode('list')} saving={saving} />
      </div>
    </AppLayout>
  );

  // ─── LIST VIEW ─────────────────────────────────────────────────────────────
  return (
    <AppLayout>
      <div className="p-6 bg-[#f8fafc] h-[calc(100vh-4rem)] flex flex-col">
        <div className="flex items-center justify-between mb-4 shrink-0">
          <div>
            <h1 className="text-xl font-bold text-[#1e293b]">
              Delivery Challans
            </h1>
            <p className="text-sm text-slate-500">{challans.length} challans</p>
          </div>
          {canCreate && (
            <button
              onClick={() => {
                resetForm();
                setMode('new');
              }}
              className="flex items-center gap-2 px-4 py-2 bg-[#4f46e5] text-white text-sm font-medium rounded-lg hover:bg-indigo-700 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line" /> New Challan
            </button>
          )}
        </div>

        <div className="bg-white border border-[#e2e8f0] rounded-xl flex-1 flex flex-col min-h-0">
          {loadingChallans ? (
            <div className="flex min-h-[260px] items-center justify-center text-slate-500 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin text-[#4f46e5]" />{' '}
                Loading challans...
              </div>
            </div>
          ) : (
            <div className="flex-1 overflow-auto hover-scrollbar bg-white min-h-0 rounded-b-xl">
              <table className="w-full min-w-[1100px] text-sm">
                <thead className="bg-slate-50 sticky top-0 z-10">
                  <tr>
                    {['Challan No', 'Date/Time', 'Customer', 'Items', 'Status', 'Invoice', 'Actions'].map((h) => (
                      <th key={h} className={`px-4 py-3 text-left text-xs font-semibold text-slate-500 border-b border-[#e2e8f0] whitespace-nowrap ${h === 'Customer' ? 'w-full' : ''}`}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {challans.map((c, i) => (
                    <tr key={c.id} onClick={async () => { const d = await loadChallanDetail(c.id); if (d) setDetailChallan(d); }}
                      className={`border-b border-slate-50 hover:bg-indigo-50/30 cursor-pointer transition-colors ${i % 2 === 1 ? 'bg-[#f8fafc]' : ''}`}>
                      <td className="px-4 py-3 font-medium text-[#4f46e5] whitespace-nowrap">
                        <span>{c.billNo}</span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <p className="text-xs text-[#1e293b]">
                          {new Date(c.date).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric' })}
                        </p>
                        {c.createdAt && (
                          <p className="text-[11px] text-[#94a3b8] mt-0.5">
                            {new Date(c.createdAt).toLocaleTimeString('en-IN', {
                              timeZone: 'Asia/Kolkata',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true,
                            })}
                          </p>
                        )}
                      </td>
                      <td className="px-4 py-3 font-medium">{c.partyName}</td>
                      <td className="px-4 py-3 text-center text-slate-500 whitespace-nowrap">{c.itemCount}</td>
                      <td className="px-4 py-3 whitespace-nowrap"><span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${STATUS_STYLES[c.challanStatus] ?? STATUS_STYLES.DRAFT}`}>{c.challanStatus}</span></td>
                      <td className="px-4 py-3 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                        {c.linkedInvoiceNumber ? (
                          <div className="flex flex-col gap-1 items-start">
                            <span className="font-medium text-[#4f46e5] text-[11px]">{c.linkedInvoiceNumber}</span>
                            {/* {c.linkedInvoiceStatus && (
                              <span className={`text-[10px] px-1.5 py-0.5 rounded-sm border inline-block w-fit ${c.linkedInvoiceStatus === 'PAID' ? 'bg-green-50 text-green-700 border-green-200' : c.linkedInvoiceStatus === 'PARTIAL' ? 'bg-orange-50 text-orange-700 border-orange-200' : 'bg-red-50 text-red-700 border-red-200'}`}>{c.linkedInvoiceStatus}</span>
                            )} */}
                          </div>
                        ) : c.challanStatus === 'DISPATCHED' && canConvert ? (
                          <button onClick={async () => {
                            const detail = await loadChallanDetail(c.id); if (!detail) return;
                            addTabWithChallan({ challanId: detail.id, challanNo: detail.billNo, customerId: detail.customerId, customerName: detail.partyName, warehouseId: detail.warehouseId, items: detail.items.map((i) => ({ itemId: i.itemId, itemName: i.itemName, qty: i.qty, unit: i.unit, rate: i.rate ?? 0 })) });
                            navigate('/sales/invoices/new');
                          }}
                            className="text-xs px-3 py-1.5 bg-indigo-50 text-[#4f46e5] border border-indigo-200 rounded-lg hover:bg-indigo-100 cursor-pointer whitespace-nowrap font-medium">
                            Convert to Invoice
                          </button>
                        ) : (
                          <span className="text-xs text-slate-400">—</span>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center gap-2 flex-nowrap">
                          <button
                            onClick={async () => {
                              const d = await loadChallanDetail(c.id);
                              if (d) setDetailChallan(d);
                            }}
                            className="h-7 px-2.5 rounded-md text-xs font-medium border border-[#e2e8f0] text-slate-600 hover:bg-slate-50 cursor-pointer whitespace-nowrap"
                          >
                            View
                          </button>

                          {c.challanStatus === 'DISPATCHED' && (
                            <>
                              {hasPermission(
                                MODULES.GATE_PASS_OUTWARD,
                                'create',
                              ) && (
                                  <button
                                    onClick={() =>
                                      handleGenerateOutwardGPFromChallan(c)
                                    }
                                    className="flex items-center gap-1.5 h-7 px-2.5 rounded-md text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 cursor-pointer whitespace-nowrap"
                                  >
                                    <i className="ri-file-shield-2-line" />{' '}
                                     GP
                                  </button>
                                )}
                            </>
                          )}

                          {canUpdate && (
                            <button
                              onClick={() => handleEditChallan(c)}
                              title="Edit challan"
                              className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 cursor-pointer"
                            >
                              <i className="ri-edit-line text-xs" />
                            </button>
                          )}
                          {canDelete && (
                            <button
                              onClick={() => setDeleteConfirmId(c.id)}
                              title="Delete challan"
                              className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-red-50 text-slate-400 hover:text-red-500 cursor-pointer"
                            >
                              <i className="ri-delete-bin-line text-xs" />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!challans.length && (
                    <tr>
                      <td
                        colSpan={6}
                        className="px-4 py-12 text-center text-slate-400"
                      >
                        No challans yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {detailChallan && (
        <ChallanDetailModal
          challan={detailChallan}
          canConvert={canConvert}
          onClose={() => setDetailChallan(null)}
          onConverted={(challanId) =>
            setChallans((prev) =>
              prev.map((ch) =>
                ch.id === challanId
                  ? { ...ch, hasSourceInvoice: true }
                  : ch,
              ),
            )
          }
        />
      )}

      <ConfirmDialog
        open={!!deleteConfirmId}
        title="Delete Challan?"
        message="This will permanently delete the challan. This action cannot be undone."
        variant="danger"
        confirmLabel="Yes, Delete"
        onConfirm={() =>
          deleteConfirmId && handleDeleteChallan(deleteConfirmId)
        }
        onCancel={() => setDeleteConfirmId(null)}
      />
    </AppLayout>
  );
}